<template>
    <div id="contendor-principal-resultados" class="container-fluid">
<!--         <div id="contenedor-encabezados-resultados" class="text-left">
            <h1>RESULTADO A CÉDULAS PENDIENTES </h1>
        </div>
        <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
            <div class="flex-grow-1 pl-3"><h4>Consulta y selección de cédula</h4></div>
        </div>
        <div id="contendor-resultados" class="area container-fluid">
            ELIMINAR <h4>Ingrese la información requerida para asignar el resultado</h4>
            <div class="row">
                <div id="filtros-resultados" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-4">
                     <FiltrosDeBusqueda class="contenedor-color-negro"
                        :posicionHorizontal="true"
                        :conSwitchHabilitacion="true" 
                        :catalogos="filtrosDeBusqueda" 
                        :ejecutaLaFuncion="evtObtenerCedulasParaResultado" 
                        :filtrosEstablecidos="filtrosEstablecidos"
                        :tituloDeBusqueda="'Paso 1: Busque las cédulas.'"
                        v-on:cambioTipoDeCedula="evtCambioTipoCedula"
                        v-on:cambioTipoNotificador="evtCambioTipoNotificador"
                        v-on:cambioTipoDeDocumento="evtCambioTipoDocumento"
                        v-on:cambioDeArea="evtCambioJuzgado"
                        v-on:AccionEnSwitchDeFiltros="evtAccionEnSwitchDeFiltros"
                        :ref="REF_FILTROS_BUSQUEDA"></FiltrosDeBusqueda> 
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-4">
                    <div>
                        <div id="contenedor-listado-cedulasEncontradas" v-show="!cargandoCedulas && this.cedulasParaAgregarResultadoBD.length > 0">
                            <div id="encabezado-tabla-cedulas" class="form-inline justify-content-between pl-4">
                                <div v-if="cambiarFiltros" class="flex-grow-1"></div>
                                <div :class="[!cambiarFiltros ? 'text-center w-100' : 'flex-grow-1 text-center pl-lg-4']"><h5>Listado de cédulas</h5></div>
                                ELIMINAR <div class="flex-grow-1 text-right"><button v-if="cambiarFiltros" @click="evtCambiarFiltrosBusqueda" type="button" class="btn-sm btn-primary"><i class="fas fa-exchange-alt"></i>&nbsp;&nbsp;Cambiar filtros</button></div>
                            </div>
                            <div class="contenedor-color-negro mb-3">
                                <div class="form-inline justify-content-end">
                                    <div id="inputs-filtro-memoria" class="form-inline pr-0">
                                        <h6 for="f-busqueda" class="mr-sm-2">Buscar:</h6>
                                        <input v-model="filtrosDeBusquedaMemoria" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control flex-grow-1"/>
                                    </div>
                                </div>
                                 <CTablaGenericaCedulas class="table-responsive mt-3"
                                    :idDelInput="ID_TABLA_CEDULAS_ENCONTRADAS"
                                    :encabezadosColumnas="encabezadosColumnas"
                                    :accionesEnTabla="this.TABLA_CEDULAS_SELECCIONADA_ACCIONES"
                                    :listaDeCedulas="listaDeCedulasFiltroMemoria"
                                    v-on:accionFuncionAgregar="evtMostrarFormularioCA"
                                    :conResponsive="true"
                                    v-on:elementosSeleccionados="evtObtenerCedulasSeleccionadas"
                                    :ref="REF_TABLA_RESULTADOS"></CTablaGenericaCedulas> 
                                <div v-if="resultados.cedulas.some(c => c.enviar) && !cargandoCedulas" class="d-flex align-items-center mt-3">
                                    <h6 class="pr-4">[#Cédulas seleccionadas: {{ resultados.cedulas.filter(c => c.enviar).length + ']'}}</h6>
                                    <button type="button" @click="evtMostrarFormulario" class="btn btn-primary justify-content-end"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Asignar resultado</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="cargandoCedulas" class="contenedor-cargando" style="height: 300px ;">
                            <div class="text-center">
                                <i class="fas fa-spinner fa-spin fa-5x"></i>
                                <h4 class="mt-4">Cargando Cédulas</h4>
                            </div>
                        </div>
                        <div v-show="!cargandoCedulas && this.cedulasParaAgregarResultadoBD.length < 1" class="contenedor-aviso-sin-resultados" style="height: 190px ;">
                            <div class="text-center">
                                <i class="fas fa-folder-open" style="font-size: 3em;"></i>
                                <h6 style="margin-top:0.5em;">No se encontraron cédulas</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- NUEVO LAYOUT -->
        <div id="encabezados-tp">
            <h1>RESULTADOS</h1>
            <h3>Crea el resultado de una o mas cédulas pendientes</h3>
            <div class="hr-titulo"></div>
        </div>
        <!-- SECCION PARA LA BUSQUEDA Y CREACION DE RESULTADOS -->
        <div class="row contendor-resultado" style="margin-top: 2rem;">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pb-3">
                <div class="card">
                    <div class="card-header">
                        <h5><strong>Filtros de busqueda</strong></h5>
                    </div>
                    <div class="card-body" style="padding: 1rem 1rem 1rem 1rem !important;">
                        <div id="filtros-resultados">
                            <FiltrosDeBusqueda 
                                :elementosAConservar= "elementosAConservar"
                                :elementosAOmitir= "elementosAOmitir"
                                :posicionHorizontal="true"
                                :conSwitchHabilitacion="true" 
                                :catalogos="filtrosDeBusqueda" 
                                :ejecutaLaFuncion="evtObtenerCedulasParaResultado" 
                                :filtrosEstablecidos="filtrosEstablecidos"
                                :tituloDeBusqueda="''"
                                v-on:cambioTipoDeCedula="evtCambioTipoCedula"
                                v-on:cambioTipoNotificador="evtCambioTipoNotificador"
                                v-on:cambioTipoDeDocumento="evtCambioTipoDocumento"
                                v-on:cambioDeArea="evtCambioJuzgado"
                                v-on:AccionEnSwitchDeFiltros="evtAccionEnSwitchDeFiltros"
                                :ref="REF_FILTROS_BUSQUEDA"></FiltrosDeBusqueda>
                        </div>  
                    </div>
                </div>
            </div>
            <!-- TABLA DE RESULTADOS -->
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-4">
                <div class="card">
                    <div class="card-header">
                        <div class="form-inline justify-content-between flex-wrap">
                            <h5><strong>Cédulas sin resultado&nbsp;&nbsp;&nbsp;[&nbsp;{{ this.cedulasParaAgregarResultadoBD.length }}&nbsp;]</strong></h5>
                            <div id="inputs-filtro-memoria" class="form-inline pr-0">
                                <input v-model="filtrosDeBusquedaMemoria" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control flex-grow-1"/>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" style="padding: 1.5rem 2rem 1.5rem 2rem !important;">
                        <div id="contenedor-listado-cedulasEncontradas" v-show="!cargandoCedulas && this.cedulasParaAgregarResultadoBD.length > 0">
                            <div v-if="resultados.cedulas.some(c => c.enviar) && !cargandoCedulas" class="d-flex align-items-center flex-wrap mb-3" style="gap: 1.5em !important;">
                                <h6><strong><i class="fas fa-check-square"></i>&nbsp;&nbsp;Cédulas: {{ resultados.cedulas.filter(c => c.enviar).length }}</strong></h6>
                                <button type="button" @click="evtMostrarFormulario" class="btn btn-light justify-content-end"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Asignar resultado</button>
                            </div>
                            <CTablaGenericaCedulas class="table-responsive"
                                :idDelInput="ID_TABLA_CEDULAS_ENCONTRADAS"
                                :encabezadosColumnas="encabezadosColumnas"
                                :accionesEnTabla="this.TABLA_CEDULAS_SELECCIONADA_ACCIONES"
                                :enableSelectAll="this.enableSelectAll"
                                :listaDeCedulas="listaDeCedulasFiltroMemoria"
                                v-on:accionFuncionAgregar="evtMostrarFormularioCA"
                                :conResponsive="true"
                                v-on:elementosSeleccionados="evtObtenerCedulasSeleccionadas"
                                :ref="REF_TABLA_RESULTADOS"></CTablaGenericaCedulas>
                        </div>
                        <div v-if="cargandoCedulas" class="contenedor-cargando" style="height: 300px ;">
                            <div class="text-center">
                                <i class="fas fa-spinner fa-spin fa-5x"></i>
                                <h4 class="mt-4">Cargando Cédulas</h4>
                            </div>
                        </div>
                        <div v-show="!cargandoCedulas && this.cedulasParaAgregarResultadoBD.length < 1" class="contenedor-aviso-sin-resultados" style="height: 190px ;">
                            <div class="text-center">
                                <i class="fas fa-folder-open" style="font-size: 3em;"></i>
                                <h6 style="margin-top:0.5em;">No se encontraron cédulas</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL PARA FORMULARIO DE RESULTADO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="formulario-resultado">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Formulario de resultado</h5>
                        <button id="btn-cerrar-formulario-resultado" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div id="modal-formulario-resultado" class="modal-body pl-4 pr-4 pt-2 pb-4">
                        <!-- PASOS -->
                       <!--  <div v-if="formulario.catalogoIndicarComo.tipoFinalizacionId" class="contenedor-pasos-formulario">
                            <ul id="barra-progreso-pasos" class="barra-progreso">
                                <li v-if="formularioResultado.pasosFormulario.uno != null" :id="formularioResultado.pasosFormulario.uno.ID" class="">{{ formularioResultado.pasosFormulario.uno.descripcion }}</li>
                                <li v-if="formularioResultado.pasosFormulario.dos != null" :id="formularioResultado.pasosFormulario.dos.ID" class="">{{ formularioResultado.pasosFormulario.dos.descripcion }}</li>
                                <li v-if="formularioResultado.pasosFormulario.tres != null" :id="formularioResultado.pasosFormulario.tres.ID" class="">{{ formularioResultado.pasosFormulario.tres.descripcion }}</li>
                            </ul>
                        </div> -->
                        <!-- FIN PASOS -->
                        <div class="contenedor-color-negro mt-3">
                            <h5>Paso 1: Elige el tipo de resultado</h5>
                            <hr />
                            <div id="campos-formulario-resultado-sa">
                                <div class="form-group">
                                    <h6 for="estatus-resultado">Estatus de cédula</h6>
                                    <!-- <input id="estatus-resultado" disabled v-model="formularioResultado.estatusCedula" type="text" class="form-control"/> -->
                                    <CCatalogoGenerico class="p-0 m-0" 
                                        v-on:valorParaElPadre="evtCambioTipoEstatusDeCedula" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="formularioResultado.catalogoEstatusDeCedula.ID" 
                                        :valorDefinido="formularioResultado.catalogoEstatusDeCedula.valorDefinido"
                                        :textoOpcionesSingular="''"
                                        :textoOpcionesPlural="''"
                                        :elementosCatalogo="formularioResultado.catalogoEstatusDeCedula.opciones"
                                        :conOpcionDeinstrucciones="formularioResultado.catalogoEstatusDeCedula.mostrarSoloOpcionesValidas"
                                        :key="formularioResultado.catalogoEstatusDeCedula.KEY + formularioResultado.catalogoEstatusDeCedula.contRender"></CCatalogoGenerico>
                                </div>
                                <div class="form-group">
                                    <h6 for="indicar-como">Indicar resultado como : &nbsp;
                                        <i v-if="formularioResultado.mostrarErroresPasoUno && this.campoRequeridoEsValido(formularioResultado.catalogoIndicarComo.tipoFinalizacionId)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                        <i v-if="formularioResultado.mostrarErroresPasoUno && !this.campoRequeridoEsValido(formularioResultado.catalogoIndicarComo.tipoFinalizacionId)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                    <CCatalogoGenerico id="indicar-como" class="p-0 m-0" 
                                        v-on:valorParaElPadre="evtCambioTipoIndicarComo($event)" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="formularioResultado.catalogoIndicarComo.id" 
                                        :valorDefinido="formularioResultado.catalogoIndicarComo.tipoFinalizacionId"
                                        :textoOpcionesSingular="formularioResultado.catalogoIndicarComo.textoSingular"
                                        :textoOpcionesPlural="formularioResultado.catalogoIndicarComo.textoPlural"
                                        :elementosCatalogo="formularioResultado.catalogoIndicarComo.tiposDeFinalizacion"
                                        :key="formularioResultado.catalogoIndicarComo.key + formularioResultado.catalogoIndicarComo.contRender"></CCatalogoGenerico>
                                </div>
                                <div v-if="this.campoRequeridoEsValido(formularioResultado.catalogoIndicarComo.tipoFinalizacionId)" class="form-group">
                                    <h6 for="tipo-resultado">Tipo de resultado</h6>
                                    <input id="tipo-resultado" disabled v-model="formularioResultado.tipoResultado.estatus" type="text" class="form-control"/>
                                </div>
                                <div v-if="formularioResultado.tipoResultado.esRazonada" class="form-group">
                                    <h6>Tipo de razonamiento&nbsp;
                                        <i v-if="formularioResultado.mostrarErroresPasoUno && this.campoRequeridoEsValido(formularioResultado.tipoResultado.razon.tipoDeRazonSeleccionada)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                        <i v-if="formularioResultado.mostrarErroresPasoUno && !this.campoRequeridoEsValido(formularioResultado.tipoResultado.razon.tipoDeRazonSeleccionada)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                    <C022TiposDeRazones class="p-0 m-0" v-on:valorParaElPadre="evtCambioTipoRazon" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="formularioResultado.catalogoTiposDeRazones.id" 
                                        :parametros="formularioResultado.catalogoTiposDeRazones.parametros"
                                        :valorDefinido="formularioResultado.catalogoTiposDeRazones.valorDefinido"
                                        :key="formularioResultado.catalogoTiposDeRazones.key + formularioResultado.catalogoTiposDeRazones.contRender"></C022TiposDeRazones>
                                </div>
                                <div class="form-group">
                                    <h6>Fecha de Resultado</h6>
                                    <input type="date" id="FechaResultado" v-model="fechaResultado" class="form-control" />
                                </div>
                                <div class="form-group">
                                    <h6>Observaciones</h6>
                                    <textarea v-model="formularioResultado.observacionesResultado" rows="3" type="text" class="form-control"/>
                                </div>
                            </div>
                        </div>
                       <!--  <div v-show="formularioResultado.pasoSeleccionado.ID == formularioResultado.pasosFormulario.dos.ID" class="contenedor-color-negro">
                            <h5>Paso 2: Elige una plantilla para el resultado</h5>
                            <hr />
                            <C009TiposPlantilla class="p-0 m-0" 
                                v-on:valorParaElPadre="evtCambioPlantilla" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="formularioResultado.catalogoPlantillas.ID" 
                                :parametros="formularioResultado.catalogoPlantillas.parametros"
                                :valorDefinido="formularioResultado.catalogoPlantillas.valorDefinido"
                                :key="formularioResultado.catalogoPlantillas.KEY + formularioResultado.catalogoPlantillas.contRender"></C009TiposPlantilla>
                            <PDFDocument v-if="this.campoRequeridoEsValido(formularioResultado.catalogoPlantillas.plantilla)" class="mt-2"
                                :url="formularioResultado.catalogoPlantillas.visorPdf.url" 
                                :ArchivoAConvertir="formularioResultado.catalogoPlantillas.visorPdf.archivo"
                                :height="formularioResultado.catalogoPlantillas.visorPdf.height"
                                :key="'VDPRIND' + formularioResultado.catalogoPlantillas.visorPdf.contRender" />
                        </div>
                         <div v-show="formularioResultado.pasoSeleccionado.ID == formularioResultado.pasosFormulario.tres.ID" class="contenedor-color-negro">
                            <h5>Paso 3: Revisa la información</h5>
                            <PDFDocument 
                                :url="formularioResultado.visorPdf.url" 
                                :ArchivoAConvertir="formularioResultado.visorPdf.archivo"
                                :height="formularioResultado.visorPdf.height"
                                :key="'VDRVR' + formularioResultado.visorPdf.contRender" />
                        </div> -->
                        <div v-if="formularioResultado.pasoSeleccionado != null" class="form-inline justify-content-between mt-3">
                            <div class="w-40">
                                <i v-if="formularioResultado.mostrarMensajeError" class="mensaje-error-formulario">(*) Debes lenar los campos obligatorios</i>
                            </div>
                            <div>
                                <!-- <button v-if="formularioResultado.pasoSeleccionado.ID != formularioResultado.pasosFormulario.uno.ID" @click="evtSeleccionPasoFormulario(false)" type="button" class="btn btn-primary mr-2"><i class="fas fa-arrow-circle-left"></i>&nbsp;Anterior</button>
                                <button v-if="formularioResultado.pasoSeleccionado.ID != formularioResultado.pasosFormulario.tres.ID" @click="evtSeleccionPasoFormulario(true)" type="button" class="btn btn-primary">Siguiente&nbsp;<i class="fas fa-arrow-circle-right"></i></button>
                                <button v-if="formularioResultado.pasoSeleccionado.ID == formularioResultado.pasosFormulario.tres.ID" @click="evtGuardarResultado(false)" type="button" class="btn btn-primary"><i class="fas fa-check-square"></i>&nbsp;Finalizar</button> -->
                                <button  @click="evtGuardarResultado(true, true)" type="button" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;Guardar</button>
                            </div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MODAL PARA FORMULARIO DE RESULTADO INDIVIDUAL-->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="formulario-resultado-individual">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Formulario de resultado {{ folioCedulaSeleccionada }}</h5>
                        <button id="btn-cerrar-formulario-resultado-individual" @click="evtCerrarFormulario" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div id="modal-formulario-resultado" class="modal-body pl-4 pr-4 pt-2 pb-4">
                        <!-- PASOS -->
                        <div v-if="this.campoRequeridoEsValido(formularioResultadoIndividual.catalogoIndicarComo.tipoFinalizacionId)" class="contenedor-pasos-formulario">
                            <ul id="barra-progreso-pasos-individual" class="barra-progreso">
                                <li v-if="formularioResultadoIndividual.pasosFormulario.uno != null" :id="formularioResultadoIndividual.pasosFormulario.uno.ID" class="">{{ formularioResultadoIndividual.pasosFormulario.uno.descripcion }}</li>
                                <li v-if="formularioResultadoIndividual.pasosFormulario.dos != null" :id="formularioResultadoIndividual.pasosFormulario.dos.ID" class="">{{ formularioResultadoIndividual.pasosFormulario.dos.descripcion }}</li>
                                <li v-if="formularioResultadoIndividual.pasosFormulario.tres != null" :id="formularioResultadoIndividual.pasosFormulario.tres.ID" class="">{{ formularioResultadoIndividual.pasosFormulario.tres.descripcion }}</li>
                                <li v-if="formularioResultadoIndividual.pasosFormulario.cuatro != null" :id="formularioResultadoIndividual.pasosFormulario.cuatro.ID" class="">{{ formularioResultadoIndividual.pasosFormulario.cuatro.descripcion }}</li>
                            </ul>
                        </div>
                        <!-- FIN PASOS -->
                        <div v-show="formularioResultadoIndividual.pasoSeleccionado.ID == formularioResultadoIndividual.pasosFormulario.uno.ID" 
                            :class="(this.campoRequeridoEsValido(formularioResultadoIndividual.catalogoIndicarComo.tipoFinalizacionId)) ? 'contenedor-color-negro' : 'contenedor-color-negro mt-3'">
                            <h5>Paso 1: Elige el tipo de resultado</h5>
                            <hr />
                            <div id="campos-formulario-resultado-sa">
                                <div class="form-group">
                                    <h6 for="estatus-resultado-individual">Estatus de cédula</h6>
                                    <!-- <input id="estatus-resultado-individual" disabled v-model="formularioResultadoIndividual.estatusCedula" type="text" class="form-control"/> -->
                                    <CCatalogoGenerico class="p-0 m-0" 
                                        v-on:valorParaElPadre="evtCambioTipoEstatusDeCedulaRI" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="formularioResultadoIndividual.catalogoEstatusDeCedula.ID" 
                                        :valorDefinido="formularioResultadoIndividual.catalogoEstatusDeCedula.valorDefinido"
                                        :textoOpcionesSingular="''"
                                        :textoOpcionesPlural="''"
                                        :elementosCatalogo="formularioResultadoIndividual.catalogoEstatusDeCedula.opciones"
                                        :conOpcionDeinstrucciones="formularioResultadoIndividual.catalogoEstatusDeCedula.mostrarSoloOpcionesValidas"
                                        :key="formularioResultadoIndividual.catalogoEstatusDeCedula.KEY + formularioResultadoIndividual.catalogoEstatusDeCedula.contRender"></CCatalogoGenerico>
                                </div>
                                <div class="form-group">
                                    <h6 for="indicar-como">Indicar resultado como : &nbsp;
                                        <i v-if="formularioResultadoIndividual.mostrarErroresPasoUno && this.campoRequeridoEsValido(formularioResultadoIndividual.catalogoIndicarComo.tipoFinalizacionId)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                        <i v-if="formularioResultadoIndividual.mostrarErroresPasoUno && !this.campoRequeridoEsValido(formularioResultadoIndividual.catalogoIndicarComo.tipoFinalizacionId)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                    <CCatalogoGenerico id="indicar-como" class="p-0 m-0" 
                                        v-on:valorParaElPadre="evtCambioTipoIndicarComo($event)" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="formularioResultadoIndividual.catalogoIndicarComo.id" 
                                        :valorDefinido="formularioResultadoIndividual.catalogoIndicarComo.tipoFinalizacionId"
                                        :textoOpcionesSingular="formularioResultadoIndividual.catalogoIndicarComo.textoSingular"
                                        :textoOpcionesPlural="formularioResultadoIndividual.catalogoIndicarComo.textoPlural"
                                        :elementosCatalogo="formularioResultadoIndividual.catalogoIndicarComo.tiposDeFinalizacion"
                                        :key="formularioResultadoIndividual.catalogoIndicarComo.key + formularioResultadoIndividual.catalogoIndicarComo.contRender"></CCatalogoGenerico>
                                </div>
                                <div v-if="this.campoRequeridoEsValido(formularioResultadoIndividual.catalogoIndicarComo.tipoFinalizacionId)" class="form-group">
                                    <h6 for="tipo-resultado">Tipo de resultado</h6>
                                    <input id="tipo-resultado" disabled v-model="formularioResultadoIndividual.tipoResultado.estatus" type="text" class="form-control"/>
                                </div>
                                <div v-if="formularioResultadoIndividual.tipoResultado.esRazonada" class="form-group">
                                    <h6>Tipo de razonamiento&nbsp;
                                        <i v-if="formularioResultadoIndividual.mostrarErroresPasoUno && this.campoRequeridoEsValido(formularioResultadoIndividual.tipoResultado.razon.tipoDeRazonSeleccionada)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                        <i v-if="formularioResultadoIndividual.mostrarErroresPasoUno && !this.campoRequeridoEsValido(formularioResultadoIndividual.tipoResultado.razon.tipoDeRazonSeleccionada)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                    <C022TiposDeRazones class="p-0 m-0" v-on:valorParaElPadre="evtCambioTipoRazon" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="formularioResultadoIndividual.catalogoTiposDeRazones.id" 
                                        :parametros="formularioResultadoIndividual.catalogoTiposDeRazones.parametros"
                                        :valorDefinido="formularioResultadoIndividual.catalogoTiposDeRazones.valorDefinido"
                                        :key="formularioResultadoIndividual.catalogoTiposDeRazones.key + formularioResultadoIndividual.catalogoTiposDeRazones.contRender"></C022TiposDeRazones>
                                </div>
                                <div v-if="mostarFechaResultado" class="form-group">
                                    <h6>Fecha de Resultado</h6>
                                    <input type="date" id="FechaResultado" v-model="fechaResultado" class="form-control" />
                                </div>
                                <div class="form-group">
                                    <h6>Observaciones</h6>
                                    <textarea v-model="formularioResultadoIndividual.observacionesResultado" rows="3" type="text" class="form-control"/>
                                </div>
                            </div>
                        </div>
                        <div v-show="formularioResultadoIndividual.pasosFormulario.dos != null && (formularioResultadoIndividual.pasoSeleccionado.ID == formularioResultadoIndividual.pasosFormulario.dos.ID)" class="contenedor-color-negro">
                            <h5>Paso 2: Elige una plantilla para el resultado</h5>
                            <hr />
                            <C009TiposPlantilla class="p-0 m-0" 
                                v-on:valorParaElPadre="evtCambioPlantilla" 
                                v-on:inicializacionPlantilla="inicializacionPlantillaDefault"
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="formularioResultadoIndividual.catalogoPlantillas.ID" 
                                :parametros="formularioResultadoIndividual.catalogoPlantillas.parametros"
                                :valorDefinido="formularioResultadoIndividual.catalogoPlantillas.valorDefinido"
                                :key="formularioResultadoIndividual.catalogoPlantillas.KEY + formularioResultadoIndividual.catalogoPlantillas.contRender"></C009TiposPlantilla>
                            <PDFDocument v-if="this.campoRequeridoEsValido(formularioResultadoIndividual.catalogoPlantillas.plantilla)" class="mt-2"
                                :url="formularioResultadoIndividual.catalogoPlantillas.visorPdf.url" 
                                :ArchivoAConvertir="formularioResultadoIndividual.catalogoPlantillas.visorPdf.archivo"
                                :height="formularioResultadoIndividual.catalogoPlantillas.visorPdf.height"
                                :key="'VDPRMULT' + formularioResultadoIndividual.catalogoPlantillas.visorPdf.contRender" />
                        </div>
                        <div v-show="formularioResultadoIndividual.pasoSeleccionado.ID == formularioResultadoIndividual.pasosFormulario.tres.ID" class="contenedor-color-negro">
                            <h5 v-if="formularioResultadoIndividual.catalogoIndicarComo.tipoFinalizacionId == enumeraciones.sinoj.tiposResultado.Razonada">Paso 3: Anexos y complementos (opcional)</h5>
                            <h5 v-if="formularioResultadoIndividual.catalogoIndicarComo.tipoFinalizacionId != enumeraciones.sinoj.tiposResultado.Razonada">Paso 2: Anexos y complementos (opcional)</h5>
                            <hr />
                            <!-- FECHA DE CONSTITICION EN DOMICILIO DE LA CEDULA -->
                            <div v-if="formularioResultadoIndividual.tipoResultado.mostarInputComplementosPlantilla" class="form-group">
                                <h6 class="mr-2">Fecha de constitución de cédula: </h6>
                                <input v-model="formularioResultadoIndividual.fechaConstitucionComplemento" type="date" class="form-control" />
                            </div>
                            <!-- FECHA DE Resultado DE LA CEDULA -->
                            <div v-if="formularioResultadoIndividual.tipoResultado.mostarInputComplementosPlantilla" class="form-group">
                                    <h6>Fecha de Resultado</h6>
                                    <input type="date" id="FechaResultado" v-model="fechaResultado" class="form-control" />
                            </div>
                            <!-- HORA DE CONSTITICION EN DOMICILIO DE LA CEDULA -->
                            <div v-if="formularioResultadoIndividual.tipoResultado.mostarInputComplementosPlantilla" class="form-group">
                                <h6 class="mr-2">Hora de constitución cédula (solo numero en letra): </h6>
                                <input v-model="formularioResultadoIndividual.horaConstitucion" type="text" class="form-control" />
                            </div>
                            <!-- MINUTO DE CONSTITICION EN DOMICILIO DE LA CEDULA -->
                            <div v-if="formularioResultadoIndividual.tipoResultado.mostarInputComplementosPlantilla" class="form-group">
                                <h6 class="mr-2">Minutos de constitución cédula (solo numero en letra): </h6>
                                <input v-model="formularioResultadoIndividual.minutoConstitucion" type="text" class="form-control" />
                            </div>
                            <!-- COMPLEMENTOS DE RESULTADO EN PLANTILLA -->
                            <div v-if="formularioResultadoIndividual.tipoResultado.mostarInputComplementosPlantilla" class="form-group">
                                <h6>Complementos a documento del resultado</h6>
                                <textarea v-model="formularioResultadoIndividual.complementosDocumentoResultado" rows="3" type="text" class="form-control"/>
                            </div>
                            <div class="form-group">
                                <h6 for="subidor-anexo">Anexo de resultado&nbsp;
                                    <i v-if="formularioResultadoIndividual.anexos.mostrarErrores && this.campoRequeridoEsValido(formularioResultadoIndividual.anexos.archivoAnexoSeleccionado)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                    <i v-if="formularioResultadoIndividual.anexos.mostrarErrores && !this.campoRequeridoEsValido(formularioResultadoIndividual.anexos.archivoAnexoSeleccionado)" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                                <div id="subidor-anexo" class="d-flex align-items-center">
                                    <input type="file" id="input-anexo-resultado" :class="[formularioResultadoIndividual.anexos.mostrarErrores && !this.campoRequeridoEsValido(formularioResultadoIndividual.anexos.archivoAnexoSeleccionado) ? 'form-control border border-danger' : 'form-control']" v-on:change="evtAgregarAnexoResultado($event)" accept=".PDF, .PNG, .JPG, .JPEG" />
                                    <button @click="evtAgregarAnexoEnLista" type="button" class="btn btn-primary ml-2"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar</button>
                                </div>
                            </div>
                            <h6 for="tabla-anexos">Anexos resultado</h6>
                            <div class="contenedor-anexos" id="tabla-anexos">
                                <div v-for="(anexo,index) in formularioResultadoIndividual.anexos.listaAnexos" :class="[(index == 0) ? 'contenido-descarga-plantilla' : 'contenido-descarga-plantilla mt-2']" :key="index">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <i :class="[anexo.iconoPdf ? 'fas fa-file-alt mr-2' : 'fas fa-image mr-2']" style="font-size: 23px;"></i>
                                        <span style="color: #000000; font-weight: bold;">{{anexo.nombre}}</span>
                                    </div>
                                    <div>
                                        <button :id="'btn-eliminar-anexo-' + anexo.referencia" @click="evtElimnarAnexoDeLista($event)" type="button" class="btn btn-primary"><i :id="'i-eliminar-anexo-' + anexo.referencia" class="fas fa-minus-square"></i>&nbsp;&nbsp;Eliminar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div v-show="formularioResultadoIndividual.pasosFormulario.cuatro != null && (formularioResultadoIndividual.pasoSeleccionado.ID == formularioResultadoIndividual.pasosFormulario.cuatro.ID)" class="contenedor-color-negro">
                            <h5 v-if="formularioResultadoIndividual.catalogoIndicarComo.tipoFinalizacionId == enumeraciones.sinoj.tiposResultado.Razonada">Paso 4: Complementar archivo (opcional).</h5>
                            <h5 v-if="formularioResultadoIndividual.catalogoIndicarComo.tipoFinalizacionId != enumeraciones.sinoj.tiposResultado.Razonada">Paso 3: Complementar archivo (opcional).</h5>
                            <hr />
                            <div class="form-group mb-2">
                                 <div class="form-group">
                                    <div class="d-flex align-items-center">
                                        <input type="file" id="input-archivoDeResultado" 
                                            :class="(formularioResultadoIndividual.documentoResultado.mostrarError && !this.campoRequeridoEsValido(formularioResultadoIndividual.documentoResultado.archivo)) ? 'border border-danger form-control mr-2' : 'form-control mr-2'" 
                                            v-on:change="evtActaulizarDocumentoResultado($event)" accept=".DOC, .DOCX, .PDF" /> 
                                        <div><button @click="evtDescargarDocumento" type="button" class="btn btn btn-success"><i class="fas fa-file-download"></i>&nbsp;Documento</button></div>
                                    </div>
                                </div>
                                <PDFDocument 
                                    :url="formularioResultadoIndividual.visorPdf.url" 
                                    :ArchivoAConvertir="formularioResultadoIndividual.visorPdf.archivo"
                                    :height="formularioResultadoIndividual.visorPdf.height"
                                    :key="'VDRVRCA' + formularioResultadoIndividual.visorPdf.contRender" />
                            </div>
                        </div>
                        <div v-if="formularioResultadoIndividual.pasoSeleccionado != null" class="form-inline justify-content-between mt-3">
                            <div class="w-40">
                                <i v-if="formularioResultadoIndividual.mostrarMensajeError" class="mensaje-error-formulario">(*) Debes lenar los campos obligatorios</i>
                            </div>
                            <div>
                                <button v-if="formularioResultadoIndividual.pasoSeleccionado.ID != formularioResultadoIndividual.pasosFormulario.uno.ID" @click="evtSeleccionPasoFormularioCA(false)" type="button" class="btn btn-primary mr-2"><i class="fas fa-arrow-circle-left"></i>&nbsp;Anterior</button>
                                <button  v-if="(formularioResultadoIndividual.catalogoIndicarComo.tipoFinalizacionId == enumeraciones.sinoj.tiposResultado.Razonada) ?
                                        formularioResultadoIndividual.pasoSeleccionado.ID != formularioResultadoIndividual.pasosFormulario.cuatro.ID :
                                        formularioResultadoIndividual.pasoSeleccionado.ID != formularioResultadoIndividual.pasosFormulario.tres.ID"
                                    @click="evtSeleccionPasoFormularioCA(true)" type="button" class="btn btn-primary">Siguiente&nbsp;<i class="fas fa-arrow-circle-right"></i></button>
                                <button v-if="(formularioResultadoIndividual.catalogoIndicarComo.tipoFinalizacionId == enumeraciones.sinoj.tiposResultado.Razonada) ?
                                        formularioResultadoIndividual.pasoSeleccionado.ID == formularioResultadoIndividual.pasosFormulario.cuatro.ID :
                                        formularioResultadoIndividual.pasoSeleccionado.ID == formularioResultadoIndividual.pasosFormulario.tres.ID"
                                    @click="evtGuardarResultado(true, true)" type="button" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;Guardar</button>
                            </div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import catalogos from '@/../static/js/catalogos'
import comun from "@/../static/js/comun"
import router from '@/router/index'
import api from '@/../static/js/api'
import axios from 'axios'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import cedulas from '../../../../../static/js/api/SINOJ/sistema/Cedulas/Cedulas'
import moment from 'moment'
import { campoEsValido, convertirCadenaAMayusculas, areasAFiltrarParaDireccion } from "../../Comun/Funciones/validaciones.js"

export default {
     components: {
        FiltrosDeBusqueda: sistemas.SINOJ.FiltrosDeBusqueda,
        CTablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas,
        CCatalogoGenerico: sistemas.SINOJ.CCatalogoGenerico,
        C022TiposDeRazones: catalogos.SINOJ.C022TiposDeRazones,
        PDFDocument,
        C009TiposPlantilla: catalogos.SINOJ.C009TiposPlantilla
    },
    data() {
        return {
            enableSelectAll: true,
            areasAFiltrarParaDireccion,
            elementosAConservar: {},
            elementosAOmitir: {},
            mostarFechaResultado : false,
            fechaResultado: moment().format('YYYY-MM-DD'),
            enumeraciones,
            ID_TABLA_CEDULAS_ENCONTRADAS: 'tablaCedulasResultados',
            REF_TABLA_RESULTADOS: 'REFtablaCedulasResultadosVRC',
             filtrosDeBusqueda: [
                { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Juzgado_Resultados' },
                { catalogoId: enumeraciones.sinoj.catalogos.Notificadores, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Notificador_Resultados' },
                { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento_Resultados' },
                { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_Resultados' },
                { catalogoId: enumeraciones.sinoj.catalogos.TiposDeCedula, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoCedula_SalidasDelDia' },
                { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'f-nExtra-VCDR' }
            ],
            REF_FILTROS_BUSQUEDA: 'REFFBVR',
            filtrosEstablecidos: {},
            encabezadosColumnas: ['Folio','Consecutivo','Juzgado','Urgente','Domicilio','Persona a notificar','Tipo de cédula',''],
            TABLA_CEDULAS_SELECCIONADA_ACCIONES: {motrarAcciones: true,check: true, eliminar: false, editar:false, agregar: true},
            listaDeCedulas: [],
            listaDeCedulasFiltroMemoria: [],
            mostrarCedulasEncontradas: false,
            cedulasParaAgregarResultadoBD: [],
            cedulasParaAgregarResultado: [],
            mesajeSinCedulas: 'No se ha realizado ninguna búsqueda, en el paso 1 presione el botón de Buscar.',
            cargandoCedulas: false,
            tipoDocumentoId: -1,
            tipoJuzgadoId: -1,
            tipoNotificadorId: -1,
            tipoDeCedulaId: -1,
            numeroDeDocumento: null,
            contadorRenderFiltros: 0,
            FILTROS_CARGADOS_PREVIAMENTE: null,
            cambiarFiltros: false,
            objCancelarFiltros: null,
            FILTROS_CARGADOS: null,
            filtrosDeBusquedaSecciones: {
                expediente: true,
                cedula: true,
                fechas: true
            },
            resultados: {
                cedulas: []
            },
            filtrosDeBusquedaMemoria: null,
            formularioResultado: {
                resultadoCedula: {
                    id: -1,
                    rutaDeDocumento: null
                },
                estatusCedula: 'SIN RESULTADO SELECCIONADO',
                mostrarErroresPasoUno: false,
                mostrarMensajeError: false,
                catalogoIndicarComo: {
                    tiposDeFinalizacion: [],
                    id: 'CTipoParaVPlantillasFiltro',
                    tipoFinalizacionId: -1,
                    textoSingular: 'modo de finalizar el resultado',
                    textoPlural: 'modos de finalizar el resultado',
                    key: 'KeyCTipoParaVPlantillasFiltro',
                    contRender: 0
                },
                catalogoTiposDeRazones: {
                    id: 'CTipoDeRazonVRC',
                    parametros: { TipoRazonId: null, Nombre: null },
                    valorDefinido: -1,
                    key: 'KCTipoDeRazonVRC',
                    contRender: 0
                },
                /* catalogoPlantillas: {
                    ID: 'CTiposPlantillasVRC',
                    parametros: { TipoPlantillaId: null, Nombre: null, TipoCedulaId: null, TipoResultadoId: null, TipoRazonId: null, FechaInicial: null, FechaFinal: null, PlantillasDe: enumeraciones.sinoj.requierenPlantilla.resultado.llave, ConInactivos: false, EsPrueba: false },
                    valorDefinido: -1,
                    KEY: 'KCTiposPlantillasVRC',
                    REF: 'RCTiposPlantillasVRC',
                    contRender: 0,
                    plantilla: null,
                    visorPdf: {
                        url: null,
                        height: '290px',
                        archivo: null,
                        contRender: 0
                    }
                }, */
                tipoResultado: {
                    estatus: 'REALIZADA',
                    esRazonada: false,
                    razon: {
                        tipoDeRazonSeleccionada: null
                    }
                },
                observacionesResultado: null,
                pasosFormulario: {
                    uno:  { ID: 'paso-uno', anterior: null, siguiente: 'paso-dos', descripcion: 'Paso 1' }/* ,
                    dos:  { ID: 'paso-dos', anterior: 'paso-uno', siguiente: 'paso-tres', descripcion: 'Paso 2' },
                    tres:  { ID: 'paso-tres', anterior: 'paso-dos', siguiente: null, descripcion: 'Paso 3' } */
                },
                pasoSeleccionado: null,
                /* visorPdf: {
                    url: null,
                    height: '400px',
                    archivo: null,
                    contRender: 0
                } */
                catalogoEstatusDeCedula: {
                    ID: 'CTiposEstatusCedula_VCDR',
                    valorDefinido: 8,
                    opciones: [ 
                                { llave: 8, valor: 'FINALIZADA' }, 
                                { llave: 12, valor: 'PARCIALMENTE FINALIZADA' } 
                            ],
                    mostrarSoloOpcionesValidas: false,
                    KEY: 'KTiposEstatusCedula_VCDR',
                    contRender: 0        
                }
            },
            formularioResultadoIndividual: {
                resultadoCedula: {
                    id: -1,
                    rutaDeDocumento: null
                },
                estatusCedula: 'SIN RESULTADO SELECCIONADO',
                mostrarErroresPasoUno: false,
                mostrarMensajeError: false,
                catalogoIndicarComo: {
                    tiposDeFinalizacion: [],
                    id: 'CTipoParaVPlantillasFiltro',
                    tipoFinalizacionId: -1,
                    textoSingular: 'modo de finalizar el resultado',
                    textoPlural: 'modos de finalizar el resultado',
                    key: 'KeyCTipoParaVPlantillasFiltro',
                    contRender: 0
                },
                catalogoTiposDeRazones: {
                    id: 'CTipoDeRazonVRC',
                    parametros: { TipoRazonId: null, Nombre: null },
                    valorDefinido: -1,
                    key: 'KCTipoDeRazonVRC',
                    contRender: 0
                },
                catalogoPlantillas: {
                    ID: 'CTiposPlantillasVRCMULT',
                    parametros: { TipoPlantillaId: null, Nombre: null, TipoCedulaId: null, TipoResultadoId: null, TipoRazonId: null, FechaInicial: null, FechaFinal: null, PlantillasDe: enumeraciones.sinoj.requierenPlantilla.razon.llave, ConInactivos: false, EsPrueba: false },
                    valorDefinido: 20, //desarrollo: 66
                    KEY: 'KCTiposPlantillasVRCMULT',
                    REF: 'RCTiposPlantillasVRCMULT',
                    contRender: 0,
                    plantilla: null,
                    visorPdf: {
                        url: '',
                        height: '290px',
                        archivo: null,
                        contRender: 0
                    }
                },
                tipoResultado: {
                    estatus: 'REALIZADA',
                    esRazonada: false,
                    razon: {
                        tipoDeRazonSeleccionada: null
                    },
                    mostarInputComplementosPlantilla: false
                },
                observacionesResultado: null,
                pasosFormulario: {
                    uno:    { ID: 'paso-uno-ca', anterior: null, siguiente: 'paso-dos-ca', descripcion: 'Paso 1' },
                    dos:    { ID: 'paso-dos-ca', anterior: 'paso-uno-ca', siguiente: 'paso-tres-ca', descripcion: 'Paso 2' },
                    tres:   { ID: 'paso-tres-ca', anterior: 'paso-dos-ca', siguiente: 'paso-cuatro-ca', descripcion: 'Paso 3' },
                    cuatro: { ID: 'paso-cuatro-ca', anterior: 'paso-tres-ca', siguiente: null, descripcion: 'Paso 4' }
                },
                pasoSeleccionado: null,
                anexos: {
                    listaAnexos: [],
                    contadorAnexos: 0,
                    archivoAnexoSeleccionado: null,
                    mostrarErrores: false
                },
                documentoResultado: {
                    archivo: null,
                    mostrarError: false,
                    realizoCambios: false
                },
                visorPdf: {
                    url: null,
                    height: '400px',
                    archivo: null,
                    contRender: 0
                },
                cedulaSeleccionada: null,
                complementosDocumentoResultado: null,
                fechaConstitucionComplemento: moment().format('YYYY-MM-DD'),
                horaConstitucion: null,
                minutoConstitucion: null,
                catalogoEstatusDeCedula: {
                    ID: 'CTiposEstatusCedulaRI_VCDR',
                    valorDefinido: 8,
                    opciones: [ 
                                { llave: 8, valor: 'FINALIZADA' }, 
                                { llave: 12, valor: 'PARCIALMENTE FINALIZADA' } 
                            ],
                    mostrarSoloOpcionesValidas: false,
                    KEY: 'KTiposEstatusCedulaRI_VCDR',
                    contRender: 0        
                }
            },
            esResultadoIndividual: false,
            cargoAreaDeUsuario: false,
            esUsuarioDeJuzgadoMixto: false
        }
    },    
    methods: {
        evtCambioTipoEstatusDeCedulaRI: function(evento) {
            this.formularioResultadoIndividual.catalogoEstatusDeCedula.valorDefinido = parseInt(evento.target.value);
        },
        evtCambioTipoEstatusDeCedula: function(evento) {
            this.formularioResultado.catalogoEstatusDeCedula.valorDefinido = parseInt(evento.target.value);
        },
        eliminarResultadoDeCedula: async function() {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_ELIMINAR = api.SINOJ.sistema.consultas.consultaDireccion.EliminarResultadosDeCedulas;
                let urlApi = SERVIDOR + METODO_API_ELIMINAR;
                let peticionArchivos = false;
                let peticionAPI = {
                    Cedulas: [this.formularioResultadoIndividual.cedulaSeleccionada],
                    esPrueba: false
                };
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error } = DATOS;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.error(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        evtDescargarDocumento: function() {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${this.formularioResultadoIndividual.resultadoCedula.rutaDeDocumento}`
            a.click();
        },
        evtActaulizarDocumentoResultado: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    this.formularioResultadoIndividual.documentoResultado.mostrarMensajeError = false;
                    this.formularioResultadoIndividual.documentoResultado.archivo = evento.target.files[0];
                    this.formularioResultadoIndividual.visorPdf.url = null;
                    this.formularioResultadoIndividual.visorPdf.archivo = this.formularioResultadoIndividual.documentoResultado.archivo;
                    this.formularioResultadoIndividual.visorPdf.contRender ++;
                }
                else {
                    this.formularioResultadoIndividual.documentoResultado.mostrarMensajeError = true;
                    this.formularioResultadoIndividual.documentoResultado.archivo = null;
                }
                this.formularioResultadoIndividual.documentoResultado.realizoCambios = true;
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        evtCerrarFormulario: function() { 
            let formulario = (this.esResultadoIndividual) ? this.formularioResultadoIndividual : this.formularioResultado;
            const PASOS_REALIZADOS = Object.values(formulario.pasosFormulario).filter(p => $("#" + p.ID).hasClass("active")).length;
            const TODOS_LOS_PASOS_TERMINADOS = (PASOS_REALIZADOS == Object.values(formulario.pasosFormulario).length);
            if(TODOS_LOS_PASOS_TERMINADOS || this.campoRequeridoEsValido(formulario.resultadoCedula.id))
                this.confirmacionResulatadoCorrecto(formulario);
            else {
                const ID_FORMULARIO = (this.esResultadoIndividual) ? 'formulario-resultado-individual' : 'formulario-resultado';
                $("#" + ID_FORMULARIO).modal('hide');
            }
        },
        confirmacionResulatadoCorrecto: function(formulario) {
            let mensaje = (this.campoRequeridoEsValido(formulario.resultadoCedula.id)) ? 
                'Se guardo parcialmente el resultado como una razon, si cierras el formulario se guardara el resultado con los datos capturados previamente en el resultado parcial (razonamiento)' : 
                'Ya has terminado todos los pasos en el formulario, si cierras el formulario se guardara el resultado con los datos capturados en los pasos del formulario';
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:`${ mensaje }.<br>¿Deseas guardar el resultado?`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;NO'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;SI'
                    }
                },
                callback: async (respuesta) => {
                    if (respuesta) {
                        const CON_MENSAJE_RESULTADO_CREADO = true;
                        this.limpiarFormulario(CON_MENSAJE_RESULTADO_CREADO);
                    }
                    else {
                        /* const ID_FORMULARIO = (this.esResultadoIndividual) ? 'formulario-resultado-individual' : 'formulario-resultado';
                        $("#" + ID_FORMULARIO).modal('show'); */
                        await Promise.resolve(this.eliminarResultadoDeCedula());
                        const CON_MENSAJE_RESULTADO_CREADO = false;
                        this.limpiarFormulario(CON_MENSAJE_RESULTADO_CREADO, true);
                    }
                }
            });
        },
        limpiarFormulario: function(conMensajeResultadoCreado, seCancelaResultado = false) { 
            let formulario = (this.esResultadoIndividual) ? this.formularioResultadoIndividual : this.formularioResultado;
            const ID_FORMULARIO = (this.esResultadoIndividual) ? 'formulario-resultado-individual' : 'formulario-resultado';
            formulario.resultadoCedula.id = -1;
            formulario.resultadoCedula.rutaDeDocumento = null;
            $("#" + ID_FORMULARIO).modal('hide');
            formulario.mostrarMensajeError = false;
            this.limpiarCamposPasoUno(formulario);
            if(this.esResultadoIndividual) {
                this.limpiarPasoDosPlantillas(formulario);
                this.limpiarCamposPasoTresAnexos(formulario);
                this.limpiarDocumentoActualizadoDeArchivo(formulario);
                this.limpiarVisualizadorDeResultado(formulario);
            }
            if(conMensajeResultadoCreado) {
                let TIPO_DE_FORMULARIO = (this.esResultadoIndividual) ? 'El resultado se creo y se guardo ' : 'Los resultados se crearon y se guardaron ';
                comun.mensajeDeAlerta(`${ TIPO_DE_FORMULARIO }de manera correcta.`);
            }

            if(!seCancelaResultado)
                this.removerCedulasConResultadoListasDeCedulas();
            this.limpiarPasos(formulario);
        },
        removerCedulasConResultadoListasDeCedulas: function() {
            // se verifica nuevamente las cedulas que estan seleccionadas para enviar
            this.resultados.cedulas = this.resultados.cedulas.filter(c => c.enviar);
            if(this.esResultadoIndividual) {
                // se elimina la cedula con resultado en caso de estar seleccionada
                this.resultados.cedulas = this.resultados.cedulas.filter(c => c.folio != this.formularioResultadoIndividual.cedulaSeleccionada.CedulaId);
                // se remueven cedulas seleccionadas de la lista de cedulas con objeto completo de bd 
                this.cedulasParaAgregarResultadoBD = this.cedulasParaAgregarResultadoBD.filter(cbd => cbd.CedulaId != this.formularioResultadoIndividual.cedulaSeleccionada.CedulaId);
                // se remueven cedulas seleccionadas de las cedulas con el formato de la tabla con filtro en memoria 
                this.listaDeCedulasFiltroMemoria = this.listaDeCedulasFiltroMemoria.filter(cm => cm.Folio != this.formularioResultadoIndividual.cedulaSeleccionada.CedulaId);
            }
            else {
                // se remueven cedulas seleccionadas de la lista de cedulas con objeto completo de bd
                this.cedulasParaAgregarResultadoBD = this.cedulasParaAgregarResultadoBD.filter(cbd => {
                    return !this.resultados.cedulas.some(cr => {
                        return cbd.CedulaId == cr.folio;
                    });
                });
                // se remueven cedulas seleccionadas de las cedulas con el formato de la tabla con filtro en memoria 
                this.listaDeCedulasFiltroMemoria = this.listaDeCedulasFiltroMemoria.filter(cfm => {
                    return !this.resultados.cedulas.some(cr => {
                        return cfm.Folio == cr.folio;
                    });
                });
                // se inicializa la lista de cedulas seleccionadas
                this.resultados.cedulas = [];
            }
            this.obtenerPersistenciaDeSeleccion();
        },
        limpiarVisualizadorDeResultado: function(formulario) {
            formulario.visorPdf.url = null;
            formulario.visorPdf.archivo = null;
            formulario.visorPdf.contRender ++;
        },
        limpiarDocumentoActualizadoDeArchivo: function(formulario) {
            formulario.documentoResultado.archivo = null;
            formulario.documentoResultado.mostrarError = false;
            formulario.documentoResultado.realizoCambios = false;
            $("#input-archivoDeResultado").val('');
        }, 
        limpiarPasoDosPlantillas: function(formulario) {
            formulario.catalogoPlantillas.parametros = { TipoPlantillaId: null, Nombre: null, TipoCedulaId: null, TipoResultadoId: null, TipoRazonId: null, FechaInicial: null, FechaFinal: null, PlantillasDe: enumeraciones.sinoj.requierenPlantilla.resultado.llave, ConInactivos: false, EsPrueba: false };
            formulario.catalogoPlantillas.plantilla = null;
            formulario.catalogoPlantillas.contRender ++;
            formulario.catalogoPlantillas.visorPdf.url = null;
            formulario.catalogoPlantillas.archivo = null;
            formulario.catalogoPlantillas.visorPdf.contRender ++;
        },
        limpiarPasos: function(formulario) {
            formulario.pasoSeleccionado = formulario.pasosFormulario.uno;
            $("#" + formulario.pasoSeleccionado.ID).addClass('active');
            Object.values(formulario.pasosFormulario).forEach(p => {
                $("#" + p.ID).removeClass('active');
            });
        },
        puedeAvanzarAOtroPaso: function() { 
            //console.log('ps::',this.formularioResultadoIndividual.pasoSeleccionado);
            let permitirAvance = true;
            if(this.esResultadoIndividual) {
                switch(this.formularioResultadoIndividual.pasoSeleccionado.ID) {
                    case 'paso-uno-ca':
                        permitirAvance = this.pasoUnoTipoDeResultadoEstaLleno(this.formularioResultadoIndividual);
                        break;
                    case 'paso-dos-ca':
                        permitirAvance = this.pasoDosEleccionDePlantilla(this.formularioResultadoIndividual);
                        break;
                }
            }
            else {
                switch(this.formularioResultado.pasoSeleccionado.ID) {
                    case 'paso-uno':
                        permitirAvance = this.pasoUnoTipoDeResultadoEstaLleno(this.formularioResultado);
                        break;
                    case 'paso-dos':
                        permitirAvance = this.pasoDosEleccionDePlantilla(this.formularioResultado);
                        break;
                }
            }
            return permitirAvance;
        },
        evtCambioPlantilla(evento,tipoPlantillaObj) { 
            console.log(tipoPlantillaObj);
            let formulario = (this.esResultadoIndividual) ? this.formularioResultadoIndividual : this.formularioResultado;
            formulario.catalogoPlantillas.plantilla = tipoPlantillaObj;
            if(this.campoRequeridoEsValido(formulario.catalogoPlantillas.plantilla)) {
                formulario.catalogoPlantillas.visorPdf.url = formulario.catalogoPlantillas.plantilla.Ruta;
                formulario.catalogoPlantillas.visorPdf.contRender ++;
                formulario.mostrarMensajeError = false;
            }
            //console.log('pv::',this.formularioResultado.catalogoPlantillas.plantilla);
        },
        inicializacionPlantillaDefault: function(tipoPlantillaObj){            
            let formulario = this.formularioResultadoIndividual;
            formulario.catalogoPlantillas.plantilla = tipoPlantillaObj; 
            if(this.campoRequeridoEsValido(formulario.catalogoPlantillas.plantilla)) {
                formulario.catalogoPlantillas.visorPdf.url = formulario.catalogoPlantillas.plantilla.Ruta;
                formulario.catalogoPlantillas.visorPdf.contRender ++;
                formulario.mostrarMensajeError = false;
            }            
        },
        evtGuardarResultado: async function(cerrarFormulario, esPasoFinal) { 
            let formulario = (this.esResultadoIndividual) ? this.formularioResultadoIndividual : this.formularioResultado;
            if(!this.esResultadoIndividual) {
                if(!this.pasoUnoTipoDeResultadoEstaLleno(this.formularioResultado))
                    return;
            }
            let cedulas = await Promise.resolve(this.obtenerCedulasParaCreacionDeResultado());
            formulario.mostrarErroresPasoUno = false;
            let peticionAPi = await Promise.resolve(this.crearPeticionDeResultado(cedulas, formulario));
            // se valida si se sucio documento complemnetado para actualizar resultado en base de datos (caso else)
            if((this.esResultadoIndividual && !this.formularioResultadoIndividual.documentoResultado.realizoCambios) && 
                (esPasoFinal && formulario.catalogoIndicarComo.tipoFinalizacionId == enumeraciones.sinoj.tiposResultado.Razonada)) {
                const CON_MENSAJE_RESULTADO_CREADO = true;
                this.limpiarFormulario(CON_MENSAJE_RESULTADO_CREADO);
            }
            else
                this.guardarResultadoBD(peticionAPi, cerrarFormulario);
        },
        /* documentoComplementadoEsValido: function(peticionAPi, cerrarFormulario) {
            let esValido = (this.formularioResultadoIndividual.catalogoIndicarComo.tipoFinalizacionId == enumeraciones.sinoj.tiposResultado.Razonada && 
               this.campoRequeridoEsValido(this.formularioResultadoIndividual.documentoResultado.archivo) || 
               !this.formularioResultadoIndividual.documentoResultado.realizoCambios);
            if(esValido)
                this.guardarResultadoBD(peticionAPi, cerrarFormulario);
            else
                comun.mensajeDeAlerta('Se detectaron campos incorrectos, <br>No puedes subir un documento vacio, verifica el archivo seleccionado.');
        }, */
        obtenerCedulasParaCreacionDeResultado: async function() {
            let cedulas = [];
            if(this.esResultadoIndividual)
                cedulas.push(this.formularioResultadoIndividual.cedulaSeleccionada);
            else
                cedulas = this.resultados.cedulas.filter(cs => cs.enviar).map(c => {
                    let cedulaObj = {};
                    cedulaObj.CedulaId = c.folio;
                    return cedulaObj;
                });
            return cedulas;
        },
        pasoDosEleccionDePlantilla: function(formulario) {
            let camposValidos = this.campoRequeridoEsValido(formulario.catalogoPlantillas.plantilla);
            formulario.mostrarMensajeError = !camposValidos;
            return camposValidos;
        },
        pasoUnoTipoDeResultadoEstaLleno: function(formulario) { 
            let camposValidos = true;
            formulario.mostrarMensajeError = false;
            formulario.mostrarErroresPasoUno = false;
            let camposObligatorios = [ {mensajeError: 'En Paso 1, debes indicar el modo de finalizar el resultado', input: formulario.catalogoIndicarComo.tipoFinalizacionId} ];
            if(formulario.catalogoIndicarComo.tipoFinalizacionId == enumeraciones.sinoj.tiposResultado.Razonada) {
                camposObligatorios.push({mensajeError: 'En Paso 1, debes seleccionar un tipo de razonamiento valido', input: formulario.tipoResultado.razon.tipoDeRazonSeleccionada});
            }
            
            for(let i=0; i < camposObligatorios.length; i++) {
                if(!this.campoRequeridoEsValido(camposObligatorios[i].input)) {
                    camposValidos = false;
                    formulario.mostrarErroresPasoUno = true;
                    formulario.mostrarMensajeError = true;
                }
            }
            return camposValidos;
        },
        crearPeticionDeResultado: async function(cedulas,formulario) {
            //const REFERENCIA_ARCHIVO_RESULTADO = 'ArchivoResultado';
            let peticion = new FormData();
            let resultados = [];
            cedulas.forEach(c => {
                let resultadoObj = {};
                resultadoObj.ResultadoId = formulario.resultadoCedula.id;
                resultadoObj.ObservacionesResultado = formulario.observacionesResultado;
                resultadoObj.FechaResultado = this.fechaResultado;
                resultadoObj.ArchivoResultado_Ruta = formulario.resultadoCedula.rutaDeDocumento;
                /* if(this.campoRequeridoEsValido(this.archivoDeResultadoSeleccionado)) {
                    resultadoObj.ArchivoResultado_Ruta = REFERENCIA_ARCHIVO_RESULTADO;
                    peticion.append(REFERENCIA_ARCHIVO_RESULTADO, this.archivoDeResultadoSeleccionado);
                } */
                let estatusCedulaObj = {
                    //TipoEstatusId: enumeraciones.sinoj.tiposEstatus.finalizado,
                    TipoEstatusId: (this.esResultadoIndividual) 
                        ? this.formularioResultadoIndividual.catalogoEstatusDeCedula.valorDefinido
                        : this.formularioResultado.catalogoEstatusDeCedula.valorDefinido
                };
                resultadoObj.Cedula = {
                    CedulaId: c.CedulaId,
                    Estatus: estatusCedulaObj
                };
                resultadoObj.TipoResultado = {
                    //TipoResultadoId: (formulario.tipoResultado.razon.tipoDeRazonSeleccionada != null) ? enumeraciones.sinoj.tiposResultado.Razonada : enumeraciones.sinoj.tiposResultado.Realizada 
                    TipoResultadoId: formulario.catalogoIndicarComo.tipoFinalizacionId
                };
                resultadoObj.TipoRazon = {
                    TipoRazonId: (formulario.tipoResultado.razon.tipoDeRazonSeleccionada) ? formulario.tipoResultado.razon.tipoDeRazonSeleccionada.TipoRazonId : -1
                };
                resultadoObj.Usuario = null;
                let anexosObj = [];
                if(this.campoRequeridoEsValido(formulario.anexos)) {
                   if(formulario.anexos.listaAnexos.length > 0) {
                        formulario.anexos.listaAnexos.forEach(a => {
                            peticion.append(a.referencia,a.archivo);
                            let anexoObj = {};
                            anexoObj.AnexoId = -1;
                            anexoObj.AnexoRuta = a.referencia;
                            anexoObj.Resultado = null;
                            anexosObj.push(anexoObj);
                        });
                    } 
                }
                resultadoObj.Anexos = anexosObj;
                resultados.push(resultadoObj);
            });
            let plantilla = (formulario.catalogoIndicarComo.tipoFinalizacionId == enumeraciones.sinoj.tiposResultado.Razonada && this.esResultadoIndividual) ? JSON.stringify(formulario.catalogoPlantillas.plantilla) : '';
            peticion.append('Plantilla',plantilla);
            peticion.append('Resultados',JSON.stringify(resultados));
            peticion.append('EsPrueba',false);
            peticion.append('ComplementosDePlantilla',JSON.stringify(this.construirComplementosDePlantilla()));
            peticion.append('DocumentoComplementado',(this.esResultadoIndividual && this.campoRequeridoEsValido(this.formularioResultadoIndividual.documentoResultado.archivo)) ? this.formularioResultadoIndividual.documentoResultado.archivo : '');
           /*  console.log('VALORES FORMDATA');
            for (var pair of peticion.entries()) {
                console.log(pair[0]+ ', ',pair[1]); 
            } */
            return peticion;
        },
        construirComplementosDePlantilla: function() { 
            /* let complemento = '';
            if(this.campoRequeridoEsValido(this.formularioResultadoIndividual.fechaConstitucionComplemento))
                complemento += (' ' + this.formularioResultadoIndividual.fechaConstitucionComplemento + ' - ');
            complemento += this.formularioResultadoIndividual.complementosDocumentoResultado;
            return complemento; */
            let complementos = {};
            //const DIA_CONSTITUCION = moment(this.formularioResultadoIndividual.fechaConstitucionComplemento.date).day();getDay()
            const DIA_CONSTITUCION = moment(this.formularioResultadoIndividual.fechaConstitucionComplemento).format('D');
            const MES_CONSTITUCION_NUMERICO = moment(this.formularioResultadoIndividual.fechaConstitucionComplemento).month();
            const MES_CONSTITUCION = moment().month(MES_CONSTITUCION_NUMERICO).format("MMMM");
            const HORA_CONSTITUCION = moment().hour();
            const MINUTO_CONSTITUCION = moment().minutes();
            complementos.DIA_RESULTADO = DIA_CONSTITUCION;
            complementos.MES_RESULTADO = MES_CONSTITUCION;
            complementos.HORA_RESULTADO = (this.campoRequeridoEsValido(this.formularioResultadoIndividual.horaConstitucion)) ? this.formularioResultadoIndividual.horaConstitucion.toUpperCase() : '_______________';
            complementos.MINUTOS_RESULTADO = (this.campoRequeridoEsValido(this.formularioResultadoIndividual.minutoConstitucion)) ? this.formularioResultadoIndividual.minutoConstitucion.toUpperCase() : '_______________';
            complementos.COMPLEMENTOS = this.formularioResultadoIndividual.complementosDocumentoResultado;
            return complementos;
        },
        guardarResultadoBD: function(peticionAPI, cerrarFormulario) {
            const SERVIDOR = api.conexion;
            const METODO_API_GUARDAR = api.SINOJ.sistema.notificaciones.resultado.GuardarResultadoDeCedula;
            let urlApi = SERVIDOR + METODO_API_GUARDAR;
            let peticionArchivos = true;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            let formularioMostradoID = (!this.esResultadoIndividual) ? 'formulario-resultado' : 'formulario-resultado-individual';
            $("#" + formularioMostradoID).modal('hide'); 
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                           if(this.esResultadoIndividual) { 
                               const RESULTADO = respuesta.data.Resultados[0];
                               // valores para identificar resultado en actualizacion
                               this.formularioResultadoIndividual.resultadoCedula.id = RESULTADO.ResultadoId;
                               this.formularioResultadoIndividual.resultadoCedula.rutaDeDocumento = RESULTADO.ArchivoResultado_Ruta;

                               this.formularioResultadoIndividual.visorPdf.archivo = null;
                               this.formularioResultadoIndividual.visorPdf.url = RESULTADO.ArchivoResultado_Ruta;
                               this.formularioResultadoIndividual.visorPdf.contRender ++;
                               // se marca como terminado y seleccionado el paso opcional final 
                               this.identificarSeleccionDePaso(true, this.formularioResultadoIndividual, this.formularioResultadoIndividual.pasosFormulario.tres);
                               // si genera documento con plantilla se habilita la posibilidad de agregar complemento, si no, termina el proceso de creacion
                               if(this.formularioResultadoIndividual.pasosFormulario.cuatro != null) {
                                  $("#" + this.formularioResultadoIndividual.pasosFormulario.cuatro.ID).addClass('active');
                                  this.limpiarDocumentoActualizadoDeArchivo(this.formularioResultadoIndividual);
                                  if(!cerrarFormulario)
                                    $("#" + formularioMostradoID).modal('show');
                               }

                               if(cerrarFormulario) {
                                   const CON_MENSAJE_RESULTADO_CREADO = true;
                                   this.limpiarFormulario(CON_MENSAJE_RESULTADO_CREADO);
                               }
                           }
                           else {
                               const CON_MENSAJE_RESULTADO_CREADO = true;
                               this.limpiarFormulario(CON_MENSAJE_RESULTADO_CREADO);
                           }
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                         $("#" + formularioMostradoID).modal('show');
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        limpiarCamposPasoUno: function(formulario) {
            formulario.estatusCedula = 'SIN RESULTADO SELECCIONADO';
            formulario.catalogoTiposDeRazones.contRender ++;
            formulario.observacionesResultado = null;
            formulario.mostrarErroresPasoUno = false;
            formulario.tipoResultado.razon.tipoDeRazonSeleccionada = null;
            formulario.catalogoIndicarComo.tipoFinalizacionId = -1;
            formulario.catalogoIndicarComo.contRender ++;
            if(this.esResultadoIndividual) {
                this.formularioResultadoIndividual.catalogoEstatusDeCedula.valorDefinido = 8;
                this.formularioResultadoIndividual.catalogoEstatusDeCedula.contRender ++;
            }
            else {
                this.formularioResultado.catalogoEstatusDeCedula.valorDefinido = 8;
                this.formularioResultado.catalogoEstatusDeCedula.contRender ++;
            }
        },
        limpiarCamposPasoTresAnexos: function() {
            $("#input-anexo-resultado").val('');
            this.formularioResultadoIndividual.anexos.listaAnexos = [];
            this.formularioResultadoIndividual.anexos.contadorAnexos = 0;
            this.formularioResultadoIndividual.anexos.mostrarErrores = false;
            this.formularioResultadoIndividual.anexos.archivoAnexoSeleccionado = null;
            this.formularioResultadoIndividual.complementosDocumentoResultado = null;
            this.formularioResultadoIndividual.horaConstitucion = null;
            this.formularioResultadoIndividual.minutoConstitucion = null;
            this.formularioResultadoIndividual.fechaConstitucionComplemento = moment().format('YYYY-MM-DD');
        },
        evtAgregarAnexoEnLista: function() {
            if(this.campoRequeridoEsValido(this.formularioResultadoIndividual.anexos.archivoAnexoSeleccionado)) {
                this.formularioResultadoIndividual.anexos.mostrarErrores = false;
                const ANEXO_AGREGADO = this.crearObjAnexo();
                this.formularioResultadoIndividual.anexos.listaAnexos.push(ANEXO_AGREGADO);
                $("#input-anexo-resultado").val('');
                this.formularioResultadoIndividual.anexos.archivoAnexoSeleccionado = null;
                this.formularioResultadoIndividual.anexos.mostrarErrores = false;
                //comun.mensajeDeAlerta('El anexo se agrego correctamente a la lista');
            }
            else {
                this.formularioResultadoIndividual.anexos.mostrarErrores = true;
                //comun.mensajeDeAlerta('Para poder agregar un anexo debes seleccionar un archivo(.PDF, .PNG, .JPG, .JPEG).');
            }
        },
        crearObjAnexo: function() {
            let anexoObj = {};
            anexoObj.referencia = this.formularioResultadoIndividual.anexos.contadorAnexos += 1;
            anexoObj.nombre = this.formularioResultadoIndividual.anexos.archivoAnexoSeleccionado.name;
            anexoObj.archivo = this.formularioResultadoIndividual.anexos.archivoAnexoSeleccionado;
            anexoObj.iconoPdf = (this.formularioResultadoIndividual.anexos.archivoAnexoSeleccionado.type == 'application/pdf') ? true : false;
            return anexoObj;
        },
        evtElimnarAnexoDeLista: function(evento) {
            const ANEXO_ID = evento.target.getAttribute('id');
            const ID_COMPLETO = ANEXO_ID.split('-');
            const ID = parseInt(ID_COMPLETO[ID_COMPLETO.length - 1]);
            this.formularioResultadoIndividual.anexos.listaAnexos = this.formularioResultadoIndividual.anexos.listaAnexos.filter(a => a.referencia != ID);
            if(this.formularioResultadoIndividual.anexos.listaAnexos.length < 1)
                this.formularioResultadoIndividual.anexos.contadorDeAnexos = 0;
            //comun.mensajeDeAlerta('El anexo se removio correctamente de la lista');
        },
        evtAgregarAnexoResultado: function(evento) { 
            try {
                if(evento.target.files.length > 0) {
                    this.formularioResultadoIndividual.anexos.archivoAnexoSeleccionado = evento.target.files[0];
                }
                else {
                    this.formularioResultadoIndividual.anexos.archivoAnexoSeleccionado = null;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        evtSeleccionPasoFormularioCA: async function(siguiente) { 
            switch(this.formularioResultadoIndividual.pasoSeleccionado.ID) {
                case 'paso-uno-ca':                    
                    this.identificarSeleccionDePaso(siguiente, this.formularioResultadoIndividual, this.formularioResultadoIndividual.pasosFormulario.uno);
                    this.identificarSeleccionDePaso(siguiente, this.formularioResultadoIndividual, this.formularioResultadoIndividual.pasosFormulario.dos);
                    break;
                case 'paso-dos-ca':
                    this.identificarSeleccionDePaso(siguiente, this.formularioResultadoIndividual, this.formularioResultadoIndividual.pasosFormulario.dos);
                    break;
                case 'paso-tres-ca':
                    if(siguiente){
                        await Promise.resolve(this.evtGuardarResultado(false, false));
                    }
                    else
                        this.identificarSeleccionDePaso(siguiente, this.formularioResultadoIndividual, this.formularioResultadoIndividual.pasosFormulario.tres);
                    break;
                case 'paso-cuatro-ca':
                     if(siguiente)
                        this.identificarSeleccionDePaso(siguiente, this.formularioResultadoIndividual, this.formularioResultadoIndividual.pasosFormulario.cuatro);
                     else
                        this.existeDocumentoActualizado();
                    break;
            }
            this.formularioResultadoIndividual.catalogoPlantillas.visorPdf.contRender ++;
        },
        existeDocumentoActualizado: function(siguiente) { 
            if(this.formularioResultadoIndividual.documentoResultado.realizoCambios) {
                $("#formulario-resultado-individual").modal('hide');
                this.informarPerdidaDeCambiosEnDocumento();
            }
            else {
                this.identificarSeleccionDePaso(siguiente, this.formularioResultadoIndividual, this.formularioResultadoIndividual.pasosFormulario.cuatro);
            }
        },
        informarPerdidaDeCambiosEnDocumento: function(siguiente) {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:`Se detecto uso del subidor de complementos, si retrocedes a unos de los pasos anteriores se perderan los cambios realizados al documento.<br>¿Deseas continuar?`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.limpiarDocumentoActualizadoDeArchivo(this.formularioResultadoIndividual);
                        this.identificarSeleccionDePaso(siguiente, this.formularioResultadoIndividual, this.formularioResultadoIndividual.pasosFormulario.cuatro);
                        const ID_FORMULARIO = (this.esResultadoIndividual) ? 'formulario-resultado-individual' : 'formulario-resultado';
                        $("#" + ID_FORMULARIO).modal('show');
                    }
                    else {
                        const ID_FORMULARIO = (this.esResultadoIndividual) ? 'formulario-resultado-individual' : 'formulario-resultado';
                        $("#" + ID_FORMULARIO).modal('show');
                    }
                }
            });
        },
        /* evtSeleccionPasoFormulario: function(siguiente) { debugger
            switch(this.formularioResultado.pasoSeleccionado.ID) {
                case 'paso-uno':
                    this.identificarSeleccionDePaso(siguiente, this.formularioResultado, this.formularioResultado.pasosFormulario.uno);
                    break;
                case 'paso-dos':
                     this.identificarSeleccionDePaso(siguiente, this.formularioResultado, this.formularioResultado.pasosFormulario.dos);
                    break;
                case 'paso-tres':
                    this.identificarSeleccionDePaso(siguiente, this.formularioResultado, this.formularioResultado.pasosFormulario.tres);
                    break;
            }
        }, */
        identificarSeleccionDePaso: function(siguiente, formulario, pasoSeleccionado) { 
            let accionRealizada = null;
            if(siguiente) {
                if(this.puedeAvanzarAOtroPaso()) {
                    $("#" + pasoSeleccionado.ID).addClass('active');
                        accionRealizada = (pasoSeleccionado.siguiente != null) ?
                            Object.values(formulario.pasosFormulario).find(p => p.ID == pasoSeleccionado.siguiente) : pasoSeleccionado
                }
                else {
                    accionRealizada = formulario.pasoSeleccionado;
                }
            }
            else {
                accionRealizada = (pasoSeleccionado.anterior != null) ?
                    Object.values(formulario.pasosFormulario).find(p => p.ID == pasoSeleccionado.anterior) : pasoSeleccionado;
                formulario.mostrarMensajeError = false;
            }
            formulario.pasoSeleccionado = accionRealizada;
        },
        evtMostrarFormulario: function() {
            this.esResultadoIndividual = false;
            $("#barra-progreso-pasos").css({ left: '8%' });
            if(this.formularioResultado.pasoSeleccionado == null)
                this.formularioResultado.pasoSeleccionado = this.formularioResultado.pasosFormulario.uno;
            $("#formulario-resultado").modal('show');
        },
        evtMostrarFormularioCA: async function(evento) {
            //console.log('entro::evento::',evento)
            this.esResultadoIndividual = true;
            if(this.formularioResultadoIndividual.catalogoIndicarComo.tipoFinalizacionId != enumeraciones.sinoj.tiposResultado.Razonada)
                $("#barra-progreso-pasos-individual").css({ right: '-20%' });
            else
                $("#barra-progreso-pasos-individual").css({ right: '4%' });
            this.formularioResultadoIndividual.cedulaSeleccionada = await Promise.resolve(this.obtenerCedulaSeleccionado(evento));
            this.obtenerUltimaFechaDeSalida({ cedula: this.formularioResultadoIndividual.cedulaSeleccionada });
            if(this.formularioResultadoIndividual.pasoSeleccionado == null)
                this.formularioResultadoIndividual.pasoSeleccionado = this.formularioResultadoIndividual.pasosFormulario.uno;
            $("#formulario-resultado-individual").modal('show');
            /* const FILTROS_CARGADOS_PREVIAMENTE = this.obtenerFiltrosDeBusquedaCargados(); */
            //router.push({ name: "EdicionResultado", params: { folio: cedulaSeleccionada.CedulaId, filtrosPrevios: this.FILTROS_CARGADOS } });
        },
        obtenerUltimaFechaDeSalida: function({ cedula }) {  
            this.formularioResultadoIndividual.fechaConstitucionComplemento = moment().format('YYYY-MM-DD');
            if(this.campoRequeridoEsValido(cedula) && this.campoRequeridoEsValido(cedula.Salidas) && cedula.Salidas.length > 0) {
                const SALIDAS_ORDENAMIENTO = cedula.Salidas.map(s => { return s.SalidaId });
                const ID_ULTIMA_SALIDA = Math.max.apply(0, SALIDAS_ORDENAMIENTO);
                const ULTIMA_SALIDA_OBJ = cedula.Salidas.find(s => s.SalidaId == ID_ULTIMA_SALIDA);
                this.formularioResultadoIndividual.fechaConstitucionComplemento = moment(ULTIMA_SALIDA_OBJ.FechaSalida).format('YYYY-MM-DD');
            }
        },
        evtCambioTipoRazon: function(evento,tipoRazonObj) {
            let formulario = (this.esResultadoIndividual) ? this.formularioResultadoIndividual : this.formularioResultado;
            formulario.tipoResultado.razon.tipoDeRazonSeleccionada = tipoRazonObj;
            const RAZON_ID = (this.campoRequeridoEsValido(tipoRazonObj)) ? tipoRazonObj.TipoRazonId : null;
            formulario.mostrarMensajeError = (RAZON_ID == null) ? true : false;
            /* if(this.esResultadoIndividual)
                this.actualizarCatalogoPlantillas(null, RAZON_ID, formulario); */
        },
        evtCambioTipoIndicarComo: function(evento) { 
            let formulario = null;
            if(this.esResultadoIndividual) {
                formulario = this.formularioResultadoIndividual;
                this.$nextTick(() => {
                     $("#barra-progreso-pasos-individual").css({ right: '4%' });
                });
                this.formularioResultadoIndividual.pasosFormulario = {
                    uno:    { ID: 'paso-uno-ca', anterior: null, siguiente: 'paso-dos-ca', descripcion: 'Paso 1' },
                    dos:    { ID: 'paso-dos-ca', anterior: 'paso-uno-ca', siguiente: 'paso-tres-ca', descripcion: 'Paso 2' },
                    tres:   { ID: 'paso-tres-ca', anterior: 'paso-dos-ca', siguiente: 'paso-cuatro-ca', descripcion: 'Paso 3' },
                    cuatro: { ID: 'paso-cuatro-ca', anterior: 'paso-tres-ca', siguiente: null, descripcion: 'Paso 4' }
                }
                this.limpiarPasoDosPlantillas(formulario);
                this.limpiarPasos(formulario);
            }
            else {
                formulario = this.formularioResultado;
            }
            this.limpiarCamposPasoUno(formulario);
            const ID_SELECCION = parseInt(evento.target.value);
            formulario.catalogoIndicarComo.tipoFinalizacionId = ID_SELECCION;
            formulario.mostrarMensajeError = false;
            switch(ID_SELECCION) {
                case enumeraciones.sinoj.tiposResultado.Realizada:
                    //this.actualizarCatalogoPlantillas(formulario.catalogoIndicarComo.tipoFinalizacionId, null, formulario);
                    formulario.estatusCedula = 'FINALIZADA'; 
                    this.actualizarCatalogoEstatusCedula({ estatusId: 8 }); // 8 = Estatus Finalizada
                    formulario.tipoResultado.estatus = 'REALIZADA'
                    formulario.tipoResultado.esRazonada = false;
                    formulario.tipoResultado.mostarInputComplementosPlantilla = false;
                    this.mostarFechaResultado = true;
                    this.asignarPasosRequeridos(formulario);
                    break;
                case enumeraciones.sinoj.tiposResultado.Razonada:
                    if(this.esResultadoIndividual)
                        this.actualizarCatalogoPlantillas(null, null, formulario);
                    formulario.estatusCedula = 'FINALIZADA';
                    let estatusDeCedula = (this.esResultadoIndividual && this.campoRequeridoEsValido(this.formularioResultadoIndividual.cedulaSeleccionada) && this.formularioResultadoIndividual.cedulaSeleccionada.TipoCedula.TipoCedulaId == 8)
                        ? 12 : 8;
                    this.actualizarCatalogoEstatusCedula({ estatusId: estatusDeCedula }); // 8 = Estatus Finalizada
                    formulario.tipoResultado.esRazonada = true;
                    this.mostarFechaResultado = false;
                    this.fechaResultado = moment().format('YYYY-MM-DD');
                    formulario.tipoResultado.estatus = 'RAZONADA'
                    formulario.tipoResultado.mostarInputComplementosPlantilla = true;
                    break; 
                case enumeraciones.sinoj.tiposResultado.ParcialmenteRealizada:
                    //this.actualizarCatalogoPlantillas(formulario.catalogoIndicarComo.tipoFinalizacionId, null, formulario);
                    formulario.estatusCedula = 'PARCIALMENTE FINALIZADA';
                    this.actualizarCatalogoEstatusCedula({ estatusId: 12 }); // 12 = PARCIALMENTE FINALIZADA
                    formulario.tipoResultado.estatus = 'PARCIALMENTE REALIZADA'
                    formulario.tipoResultado.esRazonada = false;
                    formulario.tipoResultado.mostarInputComplementosPlantilla = false;
                    this.mostarFechaResultado = true;
                    this.asignarPasosRequeridos(formulario);
                    break; 
                default:
                    formulario.mostrarMensajeError = true;
                    formulario.estatusCedula = 'SIN RESULTADO SELECCIONADO';
                    this.actualizarCatalogoEstatusCedula({ estatusId: 8 }); // 8 = Estatus Finalizada
                    formulario.tipoResultado.esRazonada = false;
                    formulario.tipoResultado.mostarInputComplementosPlantilla = false;
                    //this.actualizarCatalogoPlantillas(-1, null, formulario);
                    break;
            }
        },
        actualizarCatalogoEstatusCedula: function({ estatusId }) {
            if(this.esResultadoIndividual) {
                this.formularioResultadoIndividual.catalogoEstatusDeCedula.valorDefinido = estatusId;
                this.formularioResultadoIndividual.catalogoEstatusDeCedula.contRender ++;
            }
            else if(!this.esResultadoIndividual) {
                this.formularioResultado.catalogoEstatusDeCedula.valorDefinido = estatusId;
                this.formularioResultado.catalogoEstatusDeCedula.contRender ++;
            }
        },
        asignarPasosRequeridos: function(formulario) {
            if(this.esResultadoIndividual) {
                this.$nextTick(() => {
                    $("#barra-progreso-pasos-individual").css({ right: '-20%' });
                     //$("#barra-progreso-pasos-individual").css({ left: '8%' });
                });
                formulario.pasosFormulario = {
                    uno:    { ID: 'paso-uno-ca', anterior: null, siguiente: 'paso-tres-ca', descripcion: 'Paso 1' },
                    tres:   { ID: 'paso-tres-ca', anterior: 'paso-uno-ca', siguiente: null, descripcion: 'Paso 2' },
                    //cuatro: { ID: 'paso-cuatro-ca', anterior: 'paso-tres-ca', siguiente: null, descripcion: 'Paso 3' }
                }
            }
        },
        actualizarCatalogoPlantillas: function(resultado, razon, formulario) {
            const PLANTILLAS_PARA = (this.campoRequeridoEsValido(resultado)) ? enumeraciones.sinoj.requierenPlantilla.resultado.llave : enumeraciones.sinoj.requierenPlantilla.razon.llave;
            formulario.catalogoPlantillas.parametros.PlantillasDe = PLANTILLAS_PARA;
            formulario.catalogoPlantillas.parametros.TipoResultadoId = resultado;
            formulario.catalogoPlantillas.parametros.TipoRazonId = razon;
            formulario.catalogoPlantillas.contRender ++;
            formulario.catalogoPlantillas.plantilla = null;
        },
        obtenerPersistenciaDeSeleccion: function() {
            if(this.listaDeCedulasFiltroMemoria.length > 0) {
                let cedulasSeleccionadasConFiltros = [];
                //console.log('cedulasSalida::',this.cedulasSalida);
                this.listaDeCedulasFiltroMemoria
                .forEach(cf => {
                    const CEDULA_SELECCIONADA = this.resultados.cedulas.find(cs => cs.folio == cf.Folio);
                    //console.log('CEDULA_SELECCIONADA::',CEDULA_SELECCIONADA);
                    if(this.campoRequeridoEsValido(CEDULA_SELECCIONADA))
                       cedulasSeleccionadasConFiltros.push(CEDULA_SELECCIONADA); 
                });
                //console.log('cedulasSeleccionadasConFiltros::',cedulasSeleccionadasConFiltros);
                this.resultados.cedulas = cedulasSeleccionadasConFiltros;
            }

            // limpia los check seleccionados previamente
            if(this.listaDeCedulasFiltroMemoria.length == 0) {
                this.resultados.cedulas = [];
            }
            
            this.$nextTick(() => {
                this.resultados.cedulas.filter(c => c.enviar).forEach(cedulaSeleccionada => {
                    this.$refs[this.REF_TABLA_RESULTADOS].seleccionDeCedulaComponentePadre(cedulaSeleccionada.idCheck);
                });
            });
        },
        filtrarCedulasTabla: function(e) {
            this.listaDeCedulasFiltroMemoria = this.cedulasParaAgregarResultado
            .filter(c => {
                return Object.values(c).some(valorColumna => this.predicateFiltradoPorSimilitud(valorColumna, this.filtrosDeBusquedaMemoria));
            });
            this.obtenerPersistenciaDeSeleccion();
        },
        predicateFiltradoPorSimilitud: function(elementoAEvaluar,compararCon) { 
            if(this.campoRequeridoEsValido(compararCon)) {
                if(elementoAEvaluar.toString().toUpperCase().startsWith(compararCon.toString().toUpperCase()))
                    return true;
                else
                    return false;
            }
            else
                return true;
        },
        evtObtenerCedulasSeleccionadas: function(evento) {
            const CEDULAS_TABLA = evento;
            this.resultados.cedulas = CEDULAS_TABLA.filter(c => c.enviar);
        },
        evtAccionEnSwitchDeFiltros: function(accionRealizada) {
            switch(accionRealizada.tipoDeFiltro) {
                case 'Expediente':
                    this.filtrosDeBusquedaSecciones.expediente = accionRealizada.habilitar;
                    break;
                case 'Cedula':
                    this.filtrosDeBusquedaSecciones.cedula = accionRealizada.habilitar;
                    break;
                case 'Fechas':
                    this.filtrosDeBusquedaSecciones.fechas = accionRealizada.habilitar;
                    break;
                default:
                    break;
            };
        },
        evtCanclarFiltros: function() {
            $("#contenedor-listado-cedulasEncontradas").removeClass("desabilitar-contenedor-buscarCedula");
            $("#filtros-resultados").addClass("desabilitar-contenedor-buscarCedula");
            this.cambiarFiltros = true;
            this.objCancelarFiltros = null;
        },
        obtenerCedulaSeleccionado: async function(evento) {
            let cedula = null; 
            const CEDULA_SELECCIONADA = evento.target.getAttribute('id');
            const ID_CEDULA = parseInt(this.obtenerCedula(CEDULA_SELECCIONADA));
            this.cedulasParaAgregarResultadoBD.filter(cDB => cDB.CedulaId == ID_CEDULA).forEach(c => {
                cedula = c;
            });
            return cedula;
        },
        obtenerCedula: function(cedulaSeleccionada) {
            const CEDULA = cedulaSeleccionada.split('-');
            const POSICION_ID = (CEDULA.length - 1);
            const ID_CEDULA = CEDULA[POSICION_ID];
            return ID_CEDULA;
        },
        evtCambioTipoDocumento: function(evento) {
            const TIPO_DOCUMENTO_ID = parseInt(evento.target.value);
            this.tipoDocumentoId = (TIPO_DOCUMENTO_ID > 0) ? TIPO_DOCUMENTO_ID : -1;
        },
        evtCambioJuzgado: function(evento) {
            const TIPO_JUZGADO_ID = parseInt(evento.target.value);
            this.tipoJuzgadoId = (TIPO_JUZGADO_ID > 0) ? TIPO_JUZGADO_ID : -1;
        },
        evtCambioTipoCedula: function(evento) {
            const TIPO_CEDULA_ID = parseInt(evento.target.value);
            this.tipoDeCedulaId = (TIPO_CEDULA_ID > 0) ? TIPO_CEDULA_ID : -1;
        },
        evtCambioTipoNotificador: function(evento) {
            const TIPO_NOTIFICADOR_ID = parseInt(evento.target.value);
            this.tipoNotificadorId = (TIPO_NOTIFICADOR_ID > 0) ? TIPO_NOTIFICADOR_ID : -1;
        },
        obtenerCedulasParaResultadoBD: function() { 
           const SERVIDOR = api.conexion;
           const METODO_API_OBTENER = api.SINOJ.sistema.notificaciones.resultado.ObtenerCedulasParaResultado;
           let urlApi = SERVIDOR + METODO_API_OBTENER;
           let peticionAPI = {
                /* TipoJuzgado: (this.tipoJuzgadoId < 0 || !this.filtrosDeBusquedaSecciones.expediente) ? null : this.tipoJuzgadoId,
                TipoDocumento: (this.tipoDocumentoId < 0 || !this.filtrosDeBusquedaSecciones.expediente) ? null : this.tipoDocumentoId,
                Consecutivo: this.campoRequeridoEsValido(parseInt(this.$refs[this.REF_FILTROS_BUSQUEDA].numeroExtra)) && this.filtrosDeBusquedaSecciones.expediente ? parseInt(this.$refs[this.REF_FILTROS_BUSQUEDA].numeroExtra) : null,
                NumeroDeExpediente: this.numeroDeDocumento,
                TipoCedulaId: (this.tipoDeCedulaId < 0 || !this.filtrosDeBusquedaSecciones.cedula) ? null : this.tipoDeCedulaId,
                NotificadorId: (this.tipoNotificadorId < 0) ? null : this.tipoNotificadorId */

                TipoJuzgado: (!this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.areaId) || !this.filtrosDeBusquedaSecciones.expediente) ? null : this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.areaId,
                TipoDocumento: (!this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TipoDocumento.tipoDocumentoId) || !this.filtrosDeBusquedaSecciones.expediente) ? null : this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TipoDocumento.tipoDocumentoId,
                Consecutivo: null,
                NumeroDeExpediente: (this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo) && this.filtrosDeBusquedaSecciones.expediente) ? this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo : null,
                TipoCedulaId: (!this.campoRequeridoEsValido(this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TiposCedula.valorDefinido) || !this.filtrosDeBusquedaSecciones.cedula) ? null : this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TiposCedula.valorDefinido,
                NotificadorId: (this.tipoNotificadorId < 0) ? null : this.tipoNotificadorId
            };
            peticionAPI.esPrueba = false;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            this.cargandoCedulas = true;
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(respuesta.data.Error);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            this.cedulasParaAgregarResultadoBD = (respuesta.data.Cedulas != null) ? respuesta.data.Cedulas : [];
                            this.cedulasParaAgregarResultado = this.darFormatoCedulasTabla(this.cedulasParaAgregarResultadoBD);
                            this.listaDeCedulasFiltroMemoria = this.cedulasParaAgregarResultado;
                            this.$nextTick(() => {
                                $("#inputs-filtro-memoria input").on("change paste keyup", (e) => {
                                    if(this.cedulasParaAgregarResultado.length > 0) {
                                        this.filtrarCedulasTabla(e);
                                    }
                                });
                            });
                            this.obtenerPersistenciaDeSeleccion();

                            // 27  Notificador Ricardo Rodriguez Chavez. Se le desactivo el Select all por mal uso de este.
                            if(this.tipoNotificadorId == 27){                
                                this.enableSelectAll = false;
                                //console.log("HOLI::",this.enableSelectAll);
                            }

                        }
                        this.cargandoCedulas = false;
                        this.obtenerFiltrosDeBusquedaCargados();
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        this.cargandoCedulas = false;
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
         /**
         * funcion encargado de dar formato a objetos de cedula al formato
         * [Folio,Urgente,Tipo de cedula,Fecha de asignación] que ocupa la
         * tabla de la vista. 
         * @param {object} cedulas [fuente de datos de cedulas]
         * @see {@link cedulaAObjetoTabla}
         */
        darFormatoCedulasTabla: function(cedulas) {
            let cedulasConFormato = [];
            cedulasConFormato = cedulas.map(c => {
                let cedula = this.cedulaAObjetoTabla(c);
                return cedula;
            });
            return cedulasConFormato;
        },
        cedulaAObjetoTabla: function(cedula) {
            let cedulaObjTabla = {};
            cedulaObjTabla.Folio = cedula.CedulaId;
            cedulaObjTabla.Consecutivo = 'Sin consecutivo'; 
            cedulaObjTabla.Juzgado = 'Sin juzgado';
            if(this.campoRequeridoEsValido(cedula.Expediente)) { 
                cedulaObjTabla.Juzgado = (cedula.Expediente.Juzgado != null ) ? cedula.Expediente.Juzgado.Nombre : 'Sin juzgado';
                cedulaObjTabla.Consecutivo = cedula.Expediente.NumeroDeDocumento; 
            }
            cedulaObjTabla.urgente = (cedula.Urgente) ? 'SI' : 'NO';
            cedulaObjTabla.Domicilio = 'Sin Domicilio';
            cedulaObjTabla.PersonaANotificar = 'Sin Persona a Notificar';
            if(this.campoRequeridoEsValido(cedula.PersonasANotificar)) {
                if(cedula.PersonasANotificar[0].Domicilios != null && cedula.PersonasANotificar[0].Domicilios.length > 0) {
                    const DOMICILIO_OBJ = cedula.PersonasANotificar[0].Domicilios[0];
                    let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                    let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior.toString().trim() }` : '';
                    if(this.campoRequeridoEsValido(DOMICILIO_OBJ.Fraccionamiento)) {
                        cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`;
                    }
                    else {
                        /* 
                            para los casos de domicilios con fraccionamiento que no pertenece al catalogo de fraccionamientos, se guarda la informacion el un solo campo (008FraccionamientoFueraDeCatalogo => FraccionamientoFueraDeCatalogo)
                            con el siguiente formato NOMBRE_FRACCIONAMIENTO, NOMBRE_MUNICIPIO, si se modifica posteriormenete este formato se tendra que reemplazar esta 
                            logica.
                            */
                        let fraccionamientoCompuesto = DOMICILIO_OBJ.FraccionamientoFueraDeCatalogo.split(',');
                        let nombreFraccionamiento = fraccionamientoCompuesto[0];
                        let nombreMunicipio = fraccionamientoCompuesto[1];
                        cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ nombreFraccionamiento }, ${ nombreMunicipio }`;
                    }

                    /* const DOMICILIO_OBJ = cedula.PersonaANotificar.Domicilios[0];
                    let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                    let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior }` : '';
                    cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`; */
                }
                
                if(this.campoRequeridoEsValido(cedula.PersonasANotificar[0].DatosGenerales)) {
                    const { Fisica, Moral } = cedula.PersonasANotificar[0].DatosGenerales;
                    if(this.campoRequeridoEsValido(Fisica))
                        /* cedulaObjTabla.PersonaANotificar = `${ Fisica.Nombre.toUpperCase().trim() } ${ Fisica.ApellidoPaterno.toUpperCase().trim() }${ (this.campoRequeridoEsValido(Fisica.ApellidoMaterno)) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`;  */
                        cedulaObjTabla.PersonaANotificar = `${ convertirCadenaAMayusculas({ cadena: Fisica.Nombre }) } ${ convertirCadenaAMayusculas({ cadena: Fisica.ApellidoPaterno }) }${ (campoEsValido({ campoAValidar: Fisica.ApellidoMaterno })) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`; 
                    else if(this.campoRequeridoEsValido(Moral))
                        /* cedulaObjTabla.PersonaANotificar = `${ Moral.Nombre.trim() }`;  */
                        cedulaObjTabla.PersonaANotificar = `${ convertirCadenaAMayusculas({ cadena: Moral.Nombre }) }`; 
                }
            }
            cedulaObjTabla.TipoCedula = (this.campoRequeridoEsValido(cedula.TipoCedula.Nombre)) ? cedula.TipoCedula.Nombre.trim() : 'Sin tipo de cdula';
            // la cedula tiene una lista de asignaciones (activas, inactivas) pero activa siempre sera una, index = [0]
            // cedulaObjTabla.fechaAsignacion = cedula.AsignacionesDeNotificador[0].FechaDeAsignacion;
            /* cedulaObjTabla.numeroSalidas = 0;
            cedulaObjTabla.numeroConstituciones = 0;
            if(cedula.Salidas != null && cedula.Salidas.length > 0) {
                cedulaObjTabla.numeroSalidas = cedula.Salidas.length;
                let numeroDeContituciones = cedula.Salidas.filter(s => s.Constituciones != null).length;
                cedulaObjTabla.numeroConstituciones = numeroDeContituciones;
            } */
            //cedulaObjTabla.rutaArchivo = cedula.ArchivoRuta;
            return cedulaObjTabla;
        },
        evtObtenerCedulasParaResultado: function() {
            this.mesajeSinCedulas = (this.mesajeSinCedulas != 'No se encontraron cedulas') ? 'No se encontraron cedulas' : this.mesajeSinCedulas;
            this.objCancelarFiltros = null;
            this.obtenerCedulasParaResultadoBD();
        },
        obtenerFiltrosDeBusquedaCargados: function() {
            this.FILTROS_CARGADOS = {
                TipoJuzgado: this.tipoJuzgadoId,
                TipoDocumento: this.tipoDocumentoId,
                Consecutivo: (this.$refs[this.REF_FILTROS_BUSQUEDA].mostrarNumeroExtra) ? this.$refs[this.REF_FILTROS_BUSQUEDA].numeroExtra : null,
                NumeroDeDocumento: this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo,
                TipoCedulaId: this.tipoDeCedulaId,
                NotificadorId: this.tipoNotificadorId
            }/* 
            return FILTROS_CARGADOS */
        },
        campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'array' || campo instanceof Array) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo.length > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      asignarValoresUsuarioNotificador: async function() { 
          try {
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.sistema.notificaciones.resultado.ObtenerDatosDeNotificador;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionAPI = { esPrueba: false };
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            /* this.cargandoCedulas = true; */
            const PETICION_NOTIFICADOR = await axios.post(urlApi, peticionAPI, headerPeticion);
            const DATOS_PETICION = await PETICION_NOTIFICADOR.data;
            let { SiHayError, Error, Notificador } = DATOS_PETICION;
            if (SiHayError) {
                let mensajeError = Error.Mensaje;
                comun.SeEstaCargandoInformacion(true);
                console.log(Error);
                /* router.push({ name: "SINOJ"});
                comun.mensajeDeAlerta(mensajeError, null, null); */
            } 
            else {
                this.tipoNotificadorId = Notificador.NotificadorId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Notificadores.esInformativo = this.campoRequeridoEsValido(Notificador.NotificadorId) ? true : false;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Notificadores.valorDefinido = Notificador.NotificadorId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Notificadores.key = 'CFTN' + this.contadorRenderFiltros;
            }
          }
          catch(excepcion) {
              comun.SeEstaCargandoInformacion(false);
              console.log(excepcion);
              comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
      },
      esJuzgadoMixto: function(area) { 
          const { AreaId } = area;
          const JUZGADOS_MIXTOS = Object.values(enumeraciones.sinoj.juzgadosMixtos);
          if(this.campoRequeridoEsValido(JUZGADOS_MIXTOS)) {
            this.usuarioEsDeJuzgadoMixto = JUZGADOS_MIXTOS.some(jz => jz == AreaId);
          }
      },
    },
    async mounted() {
        $(window).on('resize', () => {
            this.formularioResultadoIndividual.catalogoPlantillas.visorPdf.contRender ++;
        });
        if(this.FILTROS_CARGADOS_PREVIAMENTE != null && this.FILTROS_CARGADOS_PREVIAMENTE != undefined) {
            // renderizar catalogos de componente hijo filtrosDeBusqueda con valor elegido previamente
            if(this.FILTROS_CARGADOS_PREVIAMENTE.cargarConFiltros) {
                this.contadorRenderFiltros += 1;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.areaId = this.tipoJuzgadoId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Area.key = 'CFJZ' + this.contadorRenderFiltros;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TipoDocumento.tipoDocumentoId = this.tipoDocumentoId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TipoDocumento.key = 'CFTD' + this.contadorRenderFiltros;
                this.$refs[this.REF_FILTROS_BUSQUEDA].consecutivo = this.numeroDeDocumento;
                if(this.FILTROS_CARGADOS_PREVIAMENTE.TipoDocumento == enumeraciones.pj.tiposDocumento.Terceria || this.FILTROS_CARGADOS_PREVIAMENTE.TipoDocumento == enumeraciones.pj.tiposDocumento.Incidente) {
                    this.$refs[this.REF_FILTROS_BUSQUEDA].numeroExtra = this.FILTROS_CARGADOS_PREVIAMENTE.Consecutivo;
                    this.$refs[this.REF_FILTROS_BUSQUEDA].mostrarNumeroExtra = true;
                }
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TiposCedula.valorDefinido = this.tipoDeCedulaId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_TiposCedula.key = 'CFTC' + this.contadorRenderFiltros;
                /* this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Notificadores.valorDefinido = this.tipoNotificadorId;
                this.$refs[this.REF_FILTROS_BUSQUEDA].parametros_Notificadores.key = 'CFTN' + this.contadorRenderFiltros; */
            }
        }

        if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area)) {
            this.cargoAreaDeUsuario = true;
            this.esJuzgadoMixto(this.$store.state.Login_Usuario.Area);

          
             await Promise.resolve(this.asignarValoresUsuarioNotificador());
        }        
        // 27  Notificador Ricardo Rodriguez Chavez. Se le desactivo el Select all por mal uso de este.
            if(this.tipoNotificadorId == 27){                
                this.enableSelectAll = false;
                //console.log("this.enableSelectAll ::",this.enableSelectAll);
            }
    },
    created() {
        //console.log('permisos::',this.$store.state.Login_PermisosDelSistema);
        //console.log('props::',router.history.current.params);
        this.FILTROS_CARGADOS_PREVIAMENTE = router.history.current.params.filtrosParaCargar;
        if(this.FILTROS_CARGADOS_PREVIAMENTE != null && this.FILTROS_CARGADOS_PREVIAMENTE != undefined) {
            if(this.FILTROS_CARGADOS_PREVIAMENTE.cargarConFiltros) {
                this.tipoJuzgadoId = this.FILTROS_CARGADOS_PREVIAMENTE.TipoJuzgado;
                this.tipoDocumentoId = this.FILTROS_CARGADOS_PREVIAMENTE.TipoDocumento
                this.numeroDeDocumento = this.FILTROS_CARGADOS_PREVIAMENTE.NumeroDeDocumento;
                this.tipoDeCedulaId = this.FILTROS_CARGADOS_PREVIAMENTE.TipoCedulaId;
                this.tipoNotificadorId = this.FILTROS_CARGADOS_PREVIAMENTE.NotificadorId;
            }
        }
        const TIPOS_FINALIZAR = enumeraciones.sinoj.tiposResultado;
        this.formularioResultado.catalogoIndicarComo.tiposDeFinalizacion = [{llave: TIPOS_FINALIZAR.Razonada, valor: 'Cédula razonada'}, {llave: TIPOS_FINALIZAR.Realizada, valor: 'Cédula realizada'}, {llave: TIPOS_FINALIZAR.ParcialmenteRealizada, valor: 'Cédula parcialmente realizada'}]; // , {llave: TIPOS_FINALIZAR.ParcialmenteRealizada, valor: 'Cédula parcialmente realizada'}
        this.formularioResultado.pasoSeleccionado = this.formularioResultado.pasosFormulario.uno;
        this.formularioResultadoIndividual.pasoSeleccionado = this.formularioResultadoIndividual.pasosFormulario.uno;
        this.formularioResultadoIndividual.catalogoIndicarComo.tiposDeFinalizacion = [{llave: TIPOS_FINALIZAR.Razonada, valor: 'Cédula razonada'}, {llave: TIPOS_FINALIZAR.Realizada, valor: 'Cédula realizada'}, {llave: TIPOS_FINALIZAR.ParcialmenteRealizada, valor: 'Cédula parcialmente realizada'}]; // , {llave: TIPOS_FINALIZAR.ParcialmenteRealizada, valor: 'Cédula parcialmente realizada'}

        // Filtros de areas.
        let filtrosAreas = areasAFiltrarParaDireccion({ areaDireccion: this.$store.state.Login_Usuario.Area.AreaId, conDireccion: true });

        if(filtrosAreas.elementosAOmitir != undefined || filtrosAreas.elementosAOmitir != null)
            this.elementosAOmitir.areas = filtrosAreas.elementosAOmitir;
        
        if(filtrosAreas.elementosAConservar != undefined || filtrosAreas.elementosAConservar != null)
            this.elementosAConservar.areas = filtrosAreas.elementosAConservar;
    },
    computed: {
        folioCedulaSeleccionada() {
            return (this.campoRequeridoEsValido(this.formularioResultadoIndividual.cedulaSeleccionada)) ? 
                `cedula [ #${ this.formularioResultadoIndividual.cedulaSeleccionada.CedulaId } ]` : '';
        }
    },
    watch: {
        'resultados.cedulas': function() {
            let todosLosElementosSeleccionados = (this.resultados.cedulas.filter(c => c.enviar).length == this.listaDeCedulasFiltroMemoria.length);
            this.$refs[this.REF_TABLA_RESULTADOS].mostrarSeleccionTodoComponentePadre(todosLosElementosSeleccionados);
        },
        '$store.state.Login_Usuario.Area': async function() {
            if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area) && !this.cargoAreaDeUsuario) {
                this.cargoAreaDeUsuario = true;
                this.esJuzgadoMixto(this.$store.state.Login_Usuario.Area);
                
                /* valor funcional antes de mixtos de jesus maria
                if(!this.usuarioEsDeJuzgadoMixto)
                    await Promise.resolve(this.asignarValoresUsuarioNotificador());
                this.obtenerCedulasParaResultadoBD();*/

                await Promise.resolve(this.asignarValoresUsuarioNotificador());
                this.obtenerCedulasParaResultadoBD();
            }            
        }
    },
}
</script>
<style scoped>
    #inputs-filtro-memoria input {
        background-color: rgb(224, 224, 224) !important;
        color: #1b1919 !important;
    }

    #encabezados-tp {
        margin-bottom: 1em;
    }

    #encabezados-tp h1 {
        margin-bottom: 0;
        font-weight: bold;
    }

    #encabezados-tp h4 {
        font-size: 1.5em;
        color: rgb(214, 214, 214);
    }

    .hr-titulo {
        height:0.5em;
        width: 6em;
        border:none;
        background-color:#ffffff;
    }

    #contendor-principal-resultados .card-header {
        background-color: rgb(70, 70, 70);
    }

    #contendor-principal-resultados .card-body {
        background-color: rgb(49, 49, 49);
    }

    #contendor-principal-resultados .card {
        border: 1px solid rgb(129, 129, 129) !important;
    }

    .contenedor-aviso-sin-resultados {
        background-color: rgb(24, 23, 23);
        height: 21rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid black;
    }

    #inputs-filtro-memoria {
        width: 50vmin;
    }

    .contenedor-anexos {
        background-color: #242425;
        max-height: 16em;
        overflow-y: auto;
        padding: 8px;
        border-radius: 4px;
    }

    .mensaje-error-formulario {
        transition-delay: 2s;
    }

    .contenido-descarga-plantilla {
        padding: 5px 9px 5px 9px;
        border-radius: 4px;
        background-color: #817c7c;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

     #titulo-tabla {
        background-color: #1b1919;
        margin-top:2em;
        padding: 10px;
        margin-bottom: 0px;
        display: flex;
        justify-content: center;
    }

    .desabilitar-contenedor-buscarCedula {
        pointer-events: none;
        opacity: 0.6;
    }

    .btn-primary:hover {
        color: white;
        background-color: black;
        border-color: white;
    }

    #encabezado-tabla-cedulas .pl-lg-4 {
        padding-left: 10em !important;
    }

    .btn-primary:focus {
        color: white;
        background-color: black;
        border-color: white;
        box-shadow: none;
    }

   .btn-primary:active, .btn-primary:visited {
        background-color: black !important;
        box-shadow: none !important;
    }

    .btn.btn-primary:disabled{
        background-color: black;
    }

    .contenedor-color-negro {
        padding: 1.5em;
        background-color: #2c2d31;
        box-shadow: 0px 6px 20px 8px #161616;
    }

    .contenedor-color-negro {
        padding: 1.5em;
        background-color: #2c2d31;
        box-shadow: 0px 6px 20px 8px #161616;
    }

    .contenedor-sin-cedula {
        background-color: rgb(36, 34, 34);
        height: 40px;
        height: 21rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .contenedor-cargando {
        background-color: rgb(36, 34, 34);
        height: 40px;
        height: 21rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .btn-sm {
        cursor: pointer;
    }

    #encabezado-contenedor-contenido {
        background-color: rgb(44, 43, 43);
        padding: 10px;
    }

    #encabezado-tabla-cedulas {
        background-color:black; 
        padding: 11px;
    }

    #encabezado-tabla-cedulas .btn-sm {
        background-color: rgb(61, 60, 60);
        padding-left: 13px;
        padding-right: 13px;
    }

  

    #formulario-resultado .modal-lg {
        max-width: 50% !important;
    }

    #formulario-resultado .modal-header {
        background-color: rgb(36, 34, 34);;
        border: none;
    }

    #formulario-resultado-individual .modal-lg {
        max-width: 50% !important;
    }

    #formulario-resultado-individual .modal-header {
        background-color: rgb(36, 34, 34);;
        border: none;
    }

    @media screen and (max-width: 600px) {
        #encabezados-tp {
            margin-bottom: 0.5em;
        }

        #encabezados-tp h1 {
            margin-bottom: 0;
            font-weight: bold;
            font-size: 1.7em !important;
        }

        #encabezados-tp h3 {
            font-size: 1.2em;
        }

        .hr-titulo {
            height:0.2em;
        }

        #contendor-principal-resultados .card-header h5 {
            font-size: 1em !important;
        }

        #contendor-principal-resultados .card-body {
            padding-right: -1em !important;
            padding-left: -100em !important;
        }

        #formulario-resultado-individual .modal-lg {
            max-width: 100% !important;
        }
    }
  

    /* BARRA PASOS */
    .contenedor-pasos-formulario {
        width: 100%;
        height: 70px;
        text-align: center;
    }

    .barra-progreso {
        counter-reset: step;
        position: relative;
        z-index: 0;
    }

    .barra-progreso li {
        list-style-type: none;
        width: 25%;
        float: left;
        font-size: 12px;
        font-weight: bold;
        position: relative;
        text-align: center;
        text-transform: uppercase;
        color: white;
    }

    .barra-progreso li:before {
        width: 30px;
        height: 30px;
        content: counter(step);
        counter-increment: step;
        line-height: 30px;
        border: 2px solid black;
        display: block;
        text-align: center;
        margin: 0 auto 4px auto;
        border-radius: 50%;
        background-color: #525357;
        cursor: pointer;
    }

    .barra-progreso li:after {
        width: 100%;
        height: 2px;
        content: '';
        position: absolute;
        background-color: #7d7d7d;
        top: 15px;
        left: -50%;
        z-index: -1;
    }

    .barra-progreso li:first-child:after {
        content: none;
    }

    .barra-progreso li.active {
        color: white;
    }

    .barra-progreso li.active:before {
        border-color: black;
        font-family: "Font Awesome 5 Free";
        content: "\f00c";
        background-color: black;
    }

    .barra-progreso li.active+li:after {
        background-color: black;
    }
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Notificaciones/Resultados/CResultados.vue